import { Component, OnInit, Input, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Chart, ChartType, ChartOptions } from 'chart.js';
import { Label, SingleDataSet } from 'ng2-charts';
import { FormBuilder } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { LookupInfo } from '../model/lookup.model';
import { environment } from 'src/environments/environment';
import { SaleTeamDetailInfo, SaleTeamInfo, SaleTeamManagementsInfo } from '../model/SaleTeamInfo.model';
import { TeamInfo } from '../model/team.model';
import { ActivatedRoute, Router } from '@angular/router';
import { param } from 'jquery';
import { TokenService } from '../service/token.service';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { SaleTargetInfo } from '../model/SaleTargetInfo.model';
import { SaleConversionRateInfo } from '../model/SaleConversionRateInfo.model';
import { ProjectPipelineInfo } from '../model/projectpipeline.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PipeLineComponent } from '../pipe-line/pipe-line.component';
import { ConversionRateDialogComponent } from '../component/conversion-rate-dialog/conversion-rate-dialog.component';
import { ServiceDeliveryBacklogDetailInfo } from '../model/ServiceDeliveryBacklogDetailInfo.model';
import { LoaderService } from '../service/loader.service';

@Component({
  selector: 'app-dashboard-sale-detail',
  templateUrl: './dashboard-sale-detail.component.html',
  styleUrls: ['./dashboard-sale-detail.component.css'],
  styles: [`
    .fade-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: white;
      opacity: 0;
      visibility: hidden;
      z-index: 1000;
      transition: opacity 0.2s ease, visibility 0.2s ease;
    }
    
    .fade-overlay.active {
      opacity: 0.9;
      visibility: visible;
    }
  `]
})
export class DashboardSaleDetailComponent implements OnInit {
  /******************************* Variables ********************************/
  baseurl: string;
  _EmpCode: string;
  _RoleCode: string;
  _ParamTeamCode: string;
  _ParamCurrentMonth: string;
  _ParamCurrentYear: string;

  // Dialog state
  dialogOpen: boolean = false;

  //ListColor: string[] = ['#20A2C0', '#44BA94', '#8AC541', '#7079B3', '#3763A8'];

  ListColor: string[] = [
    '#20A2C0', // Teal blue
    '#44BA94', // Green
    '#8AC541', // Light green
    '#7079B3', // Purple
    '#3763A8', // Dark blue
    '#FF9F43', // Orange
    '#FF6B6B', // Red
    '#4ECDC4', // Turquoise
    '#A569BD', // Purple
    '#8E44AD', // Dark purple
    '#3498DB', // Blue
    '#9B59B6', // Purple
    '#34495E', // Dark blue
    '#2ECC71', // Green
    '#E74C3C', // Red
    '#3498DB', // Blue
    '#95A5A6', // Gray
    '#1ABC9C', // Turquoise
    '#2C3E50', // Dark blue
    '#F1C40F'  // Yellow
  ]

  ListMonth: any = [];
  ListYear: number[] = [];
  ListQuarter: string[] = ['Q1', 'Q2', 'Q3', 'Q4'];

  // Month and quarter arrays for ring charts
  months: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  quarters: string[] = ['Q1', 'Q2', 'Q3', 'Q4'];

  CurrentYear: number;
  CurrentMonth: string;
  CurrentQuarter: string;

  ddlProjectType: string = null;
  ddlQuarter: string = null;
  ddlMonth: string = null;
  ddlYear: string = null;

  TotalBudget: number;
  SaleTeams: TeamInfo[] = [];
  PipelineStatusList: LookupInfo[] = []
  ListTotalSaleTeamDetails: SaleTeamManagementsInfo[] = [];
  ListSaleTeamDetails: SaleTeamManagementsInfo[] = [];
  ListTeamRank: any[] = [];
  ListSaleTarget: SaleTargetInfo[] = [];
  ListSaleConversionRate: SaleConversionRateInfo[] = [];
  ListProjectPipeline: ProjectPipelineInfo[] = [];
  private _originalPipelineData: ProjectPipelineInfo[] = null;
  private _originalSaleTeamDetails: any[] = null;
  private _originalTeamRank: any[] = null;
  SelectedTeamName: string = '';
  SaleTeamMemberMasterList: SaleTeamMappingEmployeeInfo[] = [];

  //Sale person view (รายบุคคล)
  IsSaleLead: boolean = true;
  public IsSalePersonView: boolean = false;
  currentRank: number;
  currentColor: string;
  currentEmpName: string;
  currentEmpCode: string;
  currentEmpTotalDeal: string;

  //Pie chart
  public pieChartLabels: Label[] = [];
  public pieChartData: SingleDataSet = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = false;
  public pieChartPlugins = [];
  public pieChartColors = [
    {
      backgroundColor: []
    }
  ];
  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    },
    maintainAspectRatio: false
  };

  //Column Chart
  public columnChartLabels: Label[] = [];
  public columnChartData: SingleDataSet[] = [];
  public columnChartType: ChartType = 'bar';
  public columnChartLegend = false;
  public columnChartPlugins = [];
  public columnChartColors = [
    {
      backgroundColor: []
    }
  ];
  public columnChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top'
    },
    maintainAspectRatio: false
  };

  Colors: string;
  DataSets: string;
  ChartType: string;

  ColorsPlaceholder: string;
  DataSetsPlaceholder: string;

  //Pagination
  offsetidx = 0;
  totalClosedDeal: number;
  currentPageNumber: number;
  totalPages: number;
  environment: number;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  // sale team selection
  txtSearchSaleTeam: string = null;
  SaleTeamList: SaleTeamMappingEmployeeInfo[] = [];

  chartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true
      },
      datalabels: {
        display: false,
        formatter: function (value, context) {
          const label = context.chart.data.labels[context.dataIndex];
          const percentage = context.chart.data.datasets[0].percentageLabels[context.dataIndex];
          return `${label}\n${percentage}`;
        },
        color: 'black',
        font: {
          weight: 'bold',
          size: 12
        },
        padding: 5
      }
    },
    layout: {
      padding: 15
    },
    animation: {
      animateRotate: true,
      animateScale: true
    }
  };

  chartColors: any[] = [
    {
      backgroundColor: ['#92D050', '#D9958F', '#FEE599'],
      borderColor: ['#709D3D', '#956165', '#B7A56C'],
      borderWidth: 1,
      percentageLabels: []
    }
  ];

  // Arrays to store precomputed pipeline data
  monthlyPipelineData: any[] = [];
  quarterlyPipelineData: any[] = [];
  monthlyPipelineCounts: number[] = [];
  quarterlyPipelineCounts: number[] = [];

  // Team Level Data
  _teamPipelineData: any[] = [];
  teamRegularStatuses: any[] = [];
  teamClosedStatuses: any[] = [];
  teamSpecialStatuses: any[] = [];
  teamIndependentStatuses: any[] = [];

  //loading
  isLoadingSaleTarget: boolean = false;
  isLoadingProjectCloseDealSummary: boolean = false;
  isLoadingProjectCloseDealSummaryCount: boolean = false;
  isLoadingSaleLeadFlag: boolean = false;
  isLoadingSaleConversionRate: boolean = false;
  isLoadingSaleProjectPipeline: boolean = false;

  /******************************* Variables ********************************/

  /******************************* Functions ********************************/
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private router: Router, private activateroute: ActivatedRoute, private TokenService: TokenService, public dialog: MatDialog, private loaderService: LoaderService) {
    this.baseurl = environment.base_api;
    this._ParamTeamCode = null;
    //Set param
    this.activateroute.params.subscribe(params => {
      this._ParamTeamCode = params['TeamCode'] ?? null;
      this._ParamCurrentMonth = params['Month'];
      this._ParamCurrentYear = params['Year'];

    });
  }

  async ngOnInit() {

    this._EmpCode = localStorage.getItem("EmpCode");
    this._RoleCode = localStorage.getItem("EmpRoleCode");
    if (this._RoleCode != "DIRECTOR" && this._RoleCode != "SALEDIRECTOR" && this._RoleCode != "PROJDIRECTOR" && this._RoleCode != "MANAGER") {
      this.router.navigate(['dashboardsale-detail']);
    }

    var d = new Date();
    this.ListMonth = [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ];
    for (var i = (d.getFullYear() - 15); i <= (d.getFullYear()); i++) {
      this.ListYear.push(i);
    }
    this.ListYear = this.ListYear.reverse();

    //Init ddl value
    this.ddlMonth = null;//!!this._ParamCurrentMonth ? this.ListMonth.indexOf(this._ParamCurrentMonth) + 1 : (d.getMonth() + 1).toString();
    this.ddlYear = !!this._ParamCurrentYear ? this._ParamCurrentYear : d.getFullYear().toString();

    this.CurrentYear = !!this._ParamCurrentYear ? Number(this._ParamCurrentYear) : d.getFullYear();
    this.CurrentMonth = !!this._ParamCurrentMonth ? this._ParamCurrentMonth : this.ListMonth[d.getMonth()];
    this.currentPageNumber = 1;

    //Init chart type
    this.ChartType = "Month";

    this.GlobalService.loadLookup('PIPELINESTATUS').then((data) => {
      this.PipelineStatusList = data;
    });

    await this.LoadSaleTeam("Initial");


  }

  async OnTeamChanges() {
    if (this._ParamTeamCode == undefined || this._ParamTeamCode == null || this._ParamTeamCode == "") return;

    // Make sure OnSalePerson_BackClick completes before proceeding
    await this.OnSalePerson_BackClick();

    await this.LoadSaleTeamMaster();
    await this.RefreshDashboard();
  }

  async RefreshDashboard() {

    this.isLoadingSaleTarget = true;
    this.isLoadingProjectCloseDealSummary = true;
    this.isLoadingProjectCloseDealSummaryCount = true;
    this.isLoadingSaleLeadFlag = true;
    this.isLoadingSaleConversionRate = true;
    this.isLoadingSaleProjectPipeline = true;

    try {
      console.time("LoadSaleLeadFlag");
      console.log("Calling LoadSaleLeadFlag");
      this.LoadSaleLeadFlag();
    } catch (error) {
      console.log(error);
    } finally {
      //this.isLoadingSaleLeadFlag = false;
    }

    try {
      console.time("LoadSaleTarget");
      console.log("Calling LoadSaleTarget");
      this.LoadSaleTarget();
    } catch (error) {
      console.log(error);
    } finally {
      //this.isLoadingSaleTarget = false;
    }

    try {
      console.time("LoadListProjectCloseDealSummary");
      console.log("Calling LoadListProjectCloseDealSummary");
      this.LoadListProjectCloseDealSummary();

      console.time("OnLoadCountProjectCloseDealSummary");
      console.log("Calling OnLoadCountProjectCloseDealSummary");
      this.OnLoadCountProjectCloseDealSummary();
    } catch (error) {
      console.log(error);
    } finally {
      // this.isLoadingProjectCloseDealSummary = false;
      // this.isLoadingProjectCloseDealSummaryCount = false;
    }

    try {
      console.time("LoadSaleConversionRate");
      console.log("Calling LoadSaleConversionRate");
      this.LoadSaleConversionRate();
    } catch (error) {
      console.log(error);
    } finally {
      //this.isLoadingSaleConversionRate = false;
    }

    try {
      console.time("LoadProjectPipelineList");
      console.log("Calling LoadProjectPipelineList");
      this.LoadProjectPipelineList();
    } catch (error) {
      console.log(error);
    } finally {
      //this.isLoadingSaleProjectPipeline = false;
    }









    console.log("end calling");
  }
  async LoadAllProjectClosedDeal() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      // var curDay = new Date();

      // var d = new Date('01-' + this.CurrentMonth + this.CurrentYear);
      // var days = new Date(curDay.getFullYear(), (curDay.getMonth() + 1), 0).getDate();
      // var enddate = new Date(curDay.getFullYear() + '-' + (curDay.getMonth() + 1) + '-' + days);

      // var d2 = new Date('01-' + this.CurrentMonth + this.CurrentYear)
      // d2.setMonth(d2.getMonth() - 6);
      // var startdays = new Date(d2.getFullYear(), (d2.getMonth() + 1), 0).getDate();
      // var startdate = new Date(d2.getFullYear() + '-' + (d2.getMonth() + 1) + '-' + startdays);

      // If no month is selected (All), show entire year data
      var startDate: Date;
      var endDate: Date;

      if (this.ChartType == "Month") {
        if (this.ddlMonth === null) {
          // For "All" month, show entire year
          startDate = new Date(this.CurrentYear, 0, 1); // January 1st
          endDate = new Date(this.CurrentYear, 11, 31, 23, 59); // December 31st 23:59
        } else {
          // For specific month
          var d = new Date('01-' + this.CurrentMonth + this.CurrentYear);
          var days = new Date(this.CurrentYear, (d.getMonth() + 1), 0).getDate();
          startDate = d;
          endDate = new Date(days + '-' + this.CurrentMonth + this.CurrentYear);
        }
      } else if (this.ChartType == "Quarter") {
        // Quarter view logic
        if (!this.ddlQuarter) {
          // For "All" quarters, show entire year
          startDate = new Date(this.CurrentYear, 0, 1); // January 1st
          endDate = new Date(this.CurrentYear, 11, 31, 23, 59); // December 31st 23:59
        } else {
          // For specific quarter
          var quarter = parseInt(this.ddlQuarter);
          var startMonth = (quarter - 1) * 3; // First month of the quarter
          var endMonth = startMonth + 2; // Last month of the quarter

          // Start date is first day of first month of the quarter
          startDate = new Date(this.CurrentYear, startMonth, 1);

          // End date is last day of last month of the quarter
          var lastDay = new Date(this.CurrentYear, endMonth + 1, 0).getDate();
          endDate = new Date(this.CurrentYear, endMonth, lastDay, 23, 59, 59);
        }
      }



      let offset = this.currentPageNumber != 0 ? (this.currentPageNumber - 1) * environment.PageSize : 0;
      this.offsetidx = offset;

      var objectjson = {};
      objectjson['TeamCode'] = this._ParamTeamCode;
      objectjson['EmpCode'] = !!this._ParamTeamCode ? "" : this._EmpCode;
      objectjson['StartDate'] = startDate.toLocaleDateString('en-CA');
      objectjson['EndDate'] = endDate.toLocaleDateString('en-CA');

      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);
      //console.log(strjson);

      //this.loading(true, 'Loading...');
      this.httpClient
        .post<SaleTeamDetailInfo>(this.baseurl + "Dashboard/GetAllProjectClosedDealDetails",
          strjson, httpOptions)
        .subscribe({
          next: async (data) => {
            if (data != null) {
              if (data.SaleTeamDetails != null) {
                this.ListTotalSaleTeamDetails = data.SaleTeamDetails;
                await this.SettingGoogleChartDataSetFormat(data.SaleTeamDetails);
              }
            }

            //setTimeout(() => { this.loading(false, ''); }, 1000);
          }
        });
    }
  }
  async LoadListProjectCloseDealSummary() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      //this.loading(true, 'Loading...');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // var d = new Date('01-' + this.CurrentMonth + this.CurrentYear)
      // var days = new Date(this.CurrentYear, (d.getMonth() + 1), 0).getDate();
      // var enddate = new Date(days + '-' + this.CurrentMonth + this.CurrentYear)

      // If no month is selected (All), show full year data
      var startDate: Date;
      var endDate: Date;

      if (this.ChartType == "Month") {
        if (this.ddlMonth === null) {
          // For "All" month, show entire year
          startDate = new Date(this.CurrentYear, 0, 1); // January 1st
          endDate = new Date(this.CurrentYear, 11, 31, 23, 59); // December 31st 23:59
        } else {
          // For specific month
          var d = new Date('01-' + this.CurrentMonth + this.CurrentYear);
          var days = new Date(this.CurrentYear, (d.getMonth() + 1), 0).getDate();
          startDate = d;
          endDate = new Date(days + '-' + this.CurrentMonth + this.CurrentYear);
        }
      } else if (this.ChartType == "Quarter") {
        // Quarter view logic
        if (!this.ddlQuarter) {
          // For "All" quarters, show entire year
          startDate = new Date(this.CurrentYear, 0, 1); // January 1st
          endDate = new Date(this.CurrentYear, 11, 31, 23, 59); // December 31st 23:59
        } else {
          // For specific quarter
          var quarter = parseInt(this.ddlQuarter);
          var startMonth = (quarter - 1) * 3; // First month of the quarter
          var endMonth = startMonth + 2; // Last month of the quarter

          // Start date is first day of first month of the quarter
          startDate = new Date(this.CurrentYear, startMonth, 1);

          // End date is last day of last month of the quarter
          var lastDay = new Date(this.CurrentYear, endMonth + 1, 0).getDate();
          endDate = new Date(this.CurrentYear, endMonth, lastDay, 23, 59, 59);
        }
      }

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      this.offsetidx = offset;
      var objectjson = {};
      objectjson['TeamCode'] = this._ParamTeamCode;
      objectjson['EmpCode'] = !!this._ParamTeamCode ? "" : this._EmpCode;
      //objectjson['rowFetch'] = environment.PageSize;
      //objectjson['rowOFFSet'] = offset;
      objectjson['StartDate'] = startDate.toLocaleDateString('en-CA');
      objectjson['EndDate'] = endDate.toLocaleDateString('en-CA');


      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamDetailInfo>(this.baseurl + "Dashboard/GetDashboardTeamDetails",
        strjson, httpOptions)
        .subscribe({
          next: data => {
            //debugger
            if (data != null) {
              if (!!data.SaleTeamDetails) {

                //this.loading(false, '');

                this.ListSaleTeamDetails = data.SaleTeamDetails;

                //console.log("LOAD")
                //console.log(this.ListSaleTeamDetails)

                this.TotalBudget = data.TeamTotalDeal;

                //Team Rank
                var lstTeamRank = [];
                var idx = 0;
                var tmpObj = this.GroupArrayOfObjects(data.SaleTeamDetails, "EmployeeCode");

                let addedEmp = [];

                for (var i in tmpObj) {

                  var lst = tmpObj[i];
                  var total = lst.map(o => o.ProjectSaleActualPrice).reduce((a, c) => { return a + c });
                  var objData = {};

                  var empNameArr = lst[0].EmpName.split(' ');
                  objData["EmpCode"] = i;
                  objData["EmpName"] = empNameArr[0] + ' ' + (empNameArr.length > 1 ? empNameArr[1].substr(0, 1) + '.' : '');
                  objData["TeamCode"] = lst[0].TeamCode;
                  objData["TeamColor"] = this.ListColor[idx];
                  objData["TeamTotalDeal"] = total;
                  objData["TargetAmount"] = this.GetTargetAmount({ EmployeeCode: i });
                  objData["TargetProgress"] = this.CalculateTargetProgress({ EmployeeCode: i });
                  objData["AmountLeft"] = this.CalculateAmountLeft({ EmployeeCode: i });

                  lstTeamRank.push(objData);
                  addedEmp.push(i);
                  idx++;
                }

                // Add Employee without Data to Graph
                for (var y in this.SaleTeamMemberMasterList) {

                  // Check if y.EmployeeCode exists in addedEmp, if yes, continue
                  if (addedEmp.includes(this.SaleTeamMemberMasterList[y].EmployeeCode)) {
                    continue;
                  }

                  let objData = {};

                  let empNameArr = this.SaleTeamMemberMasterList[y].EmployeeName.split(' ');
                  objData["EmpCode"] = this.SaleTeamMemberMasterList[y].EmployeeCode;
                  objData["EmpName"] = empNameArr[0] + ' ' + (empNameArr.length > 1 ? empNameArr[1].substr(0, 1) + '.' : '');
                  objData["TeamCode"] = this.SaleTeamMemberMasterList[y].SaleTeamCode;
                  objData["TeamColor"] = this.ListColor[idx];
                  objData["TeamTotalDeal"] = 0;
                  objData["TargetAmount"] = this.GetTargetAmount({ EmployeeCode: this.SaleTeamMemberMasterList[y].EmployeeCode });
                  objData["TargetProgress"] = this.CalculateTargetProgress({ EmployeeCode: this.SaleTeamMemberMasterList[y].EmployeeCode });
                  objData["AmountLeft"] = this.CalculateAmountLeft({ EmployeeCode: this.SaleTeamMemberMasterList[y].EmployeeCode });

                  lstTeamRank.push(objData);
                  //addedEmp.push(i);
                  idx++;

                }

                addedEmp = [];

                lstTeamRank = lstTeamRank.sort(function (a, b) {
                  return a.TeamTotalDeal - b.TeamTotalDeal;
                });
                this.ListTeamRank = lstTeamRank.reverse();


                //Pie chart
                this.pieChartLabels = [];
                this.pieChartData = [];
                this.pieChartColors[0].backgroundColor = [];
                this.ListTeamRank.forEach((traget, indextraget) => {
                  this.pieChartLabels.push(traget.EmpName);
                  this.pieChartData.push(traget.TeamTotalDeal);
                  this.pieChartColors[0].backgroundColor.push(this.ListColor[indextraget])
                });

                this.CheckLeadFlag();

              } else {

                // Add placeholder


                //this.loading(false, '');

                this.ListSaleTeamDetails = data.SaleTeamDetails;

                //console.log("LOAD")
                //console.log(this.ListSaleTeamDetails)

                this.TotalBudget = data.TeamTotalDeal;

                //Team Rank
                var lstTeamRank = [];
                var idx = 0;
                var tmpObj = this.GroupArrayOfObjects(data.SaleTeamDetails, "EmployeeCode");

                let addedEmp = [];

                for (var i in tmpObj) {

                  var lst = tmpObj[i];
                  var total = lst.map(o => o.ProjectSaleActualPrice).reduce((a, c) => { return a + c });
                  var objData = {};

                  var empNameArr = lst[0].EmpName.split(' ');
                  objData["EmpCode"] = i;
                  objData["EmpName"] = empNameArr[0] + ' ' + (empNameArr.length > 1 ? empNameArr[1].substr(0, 1) + '.' : '');
                  objData["TeamCode"] = lst[0].TeamCode;
                  objData["TeamColor"] = this.ListColor[idx];
                  objData["TeamTotalDeal"] = total;
                  objData["TargetAmount"] = this.GetTargetAmount({ EmployeeCode: i });
                  objData["TargetProgress"] = this.CalculateTargetProgress({ EmployeeCode: i });
                  objData["AmountLeft"] = this.CalculateAmountLeft({ EmployeeCode: i });

                  lstTeamRank.push(objData);
                  addedEmp.push(i);
                  idx++;
                }



                // Add Employee without Data to Graph
                for (var y in this.SaleTeamMemberMasterList) {

                  // Check if y.EmployeeCode exists in addedEmp, if yes, continue
                  if (addedEmp.includes(this.SaleTeamMemberMasterList[y].EmployeeCode)) {
                    continue;
                  }

                  let objData = {};

                  let empNameArr = this.SaleTeamMemberMasterList[y].EmployeeName.split(' ');
                  objData["EmpCode"] = this.SaleTeamMemberMasterList[y].EmployeeCode;
                  objData["EmpName"] = empNameArr[0] + ' ' + (empNameArr.length > 1 ? empNameArr[1].substr(0, 1) + '.' : '');
                  objData["TeamCode"] = this.SaleTeamMemberMasterList[y].SaleTeamCode;
                  objData["TeamColor"] = this.ListColor[idx];
                  objData["TeamTotalDeal"] = 0;
                  objData["TargetAmount"] = this.GetTargetAmount({ EmployeeCode: this.SaleTeamMemberMasterList[y].EmployeeCode });
                  objData["TargetProgress"] = this.CalculateTargetProgress({ EmployeeCode: this.SaleTeamMemberMasterList[y].EmployeeCode });
                  objData["AmountLeft"] = this.CalculateAmountLeft({ EmployeeCode: this.SaleTeamMemberMasterList[y].EmployeeCode });

                  lstTeamRank.push(objData);
                  //addedEmp.push(i);
                  idx++;

                }

                addedEmp = [];

                lstTeamRank = lstTeamRank.sort(function (a, b) {
                  return a.TeamTotalDeal - b.TeamTotalDeal;
                });
                this.ListTeamRank = lstTeamRank.reverse();


                //Pie chart
                this.pieChartLabels = [];
                this.pieChartData = [];
                this.pieChartColors[0].backgroundColor = [];
                this.ListTeamRank.forEach((traget, indextraget) => {
                  this.pieChartLabels.push(traget.EmpName);
                  this.pieChartData.push(traget.TeamTotalDeal);
                  this.pieChartColors[0].backgroundColor.push(this.ListColor[indextraget])
                });

                console.log(this.ListTeamRank)

                this.CheckLeadFlag();

              }
            }

            console.timeEnd("LoadListProjectCloseDealSummary");
            this.isLoadingProjectCloseDealSummary = false;
          }
        });
    }
  }
  async LoadCountProjectCloseDealSummary(): Promise<any> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // If no month is selected (All), show full year data
      var startDate: Date;
      var endDate: Date;

      if (this.ChartType == "Month") {
        if (this.ddlMonth === null) {
          // For "All" month, show entire year
          startDate = new Date(this.CurrentYear, 0, 1); // January 1st
          endDate = new Date(this.CurrentYear, 11, 31, 23, 59); // December 31st 23:59
        } else {
          // For specific month
          var d = new Date('01-' + this.CurrentMonth + this.CurrentYear);
          var days = new Date(this.CurrentYear, (d.getMonth() + 1), 0).getDate();
          startDate = d;
          endDate = new Date(days + '-' + this.CurrentMonth + this.CurrentYear);
        }
      } else if (this.ChartType == "Quarter") {
        // Quarter view logic
        if (!this.ddlQuarter) {
          // For "All" quarters, show entire year
          startDate = new Date(this.CurrentYear, 0, 1); // January 1st
          endDate = new Date(this.CurrentYear, 11, 31, 23, 59); // December 31st 23:59
        } else {
          // For specific quarter
          var quarter = parseInt(this.ddlQuarter);
          var startMonth = (quarter - 1) * 3; // First month of the quarter
          var endMonth = startMonth + 2; // Last month of the quarter

          // Start date is first day of first month of the quarter
          startDate = new Date(this.CurrentYear, startMonth, 1);

          // End date is last day of last month of the quarter
          var lastDay = new Date(this.CurrentYear, endMonth + 1, 0).getDate();
          endDate = new Date(this.CurrentYear, endMonth, lastDay, 23, 59, 59);
        }
      }

      var objectjson = {};
      objectjson['TeamCode'] = this._ParamTeamCode;
      objectjson['EmpCode'] = !!this._ParamTeamCode ? "" : this._EmpCode;
      objectjson['StartDate'] = startDate.toLocaleDateString('en-CA');
      objectjson['EndDate'] = endDate.toLocaleDateString('en-CA');
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "Dashboard/GetCountDashboardTeamDetails",
          strjson, httpOptions)
        .toPromise().then((data) => {
          this.isLoadingProjectCloseDealSummaryCount = false;
          console.timeEnd("OnLoadCountProjectCloseDealSummary");
          return data;
        });
    }
    return Promise.resolve(0); // Return a resolved promise with 0 count if no auth token
  }
  async LoadSaleLeadFlag() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var d = new Date('01-' + this.CurrentMonth + this.CurrentYear)
      var days = new Date(this.CurrentYear, (d.getMonth() + 1), 0).getDate();
      var enddate = new Date(days + '-' + this.CurrentMonth + this.CurrentYear)

      var objectjson = {};
      objectjson['EmpCode'] = this._EmpCode;
      objectjson['TeamCode'] = this._ParamTeamCode;
      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<boolean>(this.baseurl + "Dashboard/GetSaleLeadFlag",
        strjson, httpOptions)
        .toPromise().then(data => {
          this.IsSaleLead = data;

          // if (!this.IsSaleLead) {

          //   this.IsSalePersonView = true;

          // }
          this.CheckLeadFlag();

          this.isLoadingSaleLeadFlag = false;
          console.timeEnd("LoadSaleLeadFlag");
        });
    }
  }

  async OnDdlQuarterChange() {
    this.CurrentQuarter = this.ListQuarter[Number(this.ddlQuarter) - 1];

    await this.RefreshDashboard();
  }

  async OnDdlMonthChange() {


    this.CurrentMonth = this.ListMonth[Number(this.ddlMonth) - 1];

    await this.RefreshDashboard();
  }
  async OnDdlYearChange() {
    this.CurrentYear = Number(this.ddlYear);

    await this.RefreshDashboard();
  }
  OnBackClick() {
    this.router.navigate(["/dashboard-sale", { Month: this.CurrentMonth, Year: this.CurrentYear }]);
  }
  async OnSalePerson_Click(idx, data: any) {
    // If we're already in sale person view, save the current data back to original
    if (this.IsSalePersonView) {
      // First restore the original data if we're switching between employees
      await this.OnSalePerson_BackClick(false); // Don't reload data, just restore originals
    }

    this.IsSalePersonView = true;

    // Store the original team data for this employee
    const originalTeamData = { ...data };

    // Store the original ListSaleTeamDetails if not already stored
    if (!this._originalSaleTeamDetails) {
      this._originalSaleTeamDetails = [...this.ListSaleTeamDetails];
    }

    // Store the original ListTeamRank if needed
    if (!this._originalTeamRank) {
      this._originalTeamRank = [...this.ListTeamRank];
    }

    // Store the original pipeline data if not already stored
    if (!this._originalPipelineData && this.ListProjectPipeline && this.ListProjectPipeline.length > 0) {
      this._originalPipelineData = [...this.ListProjectPipeline];
    }

    // Find the employee in the SaleTeamMemberMasterList to get the full name
    if (this.SaleTeamMemberMasterList && this.SaleTeamMemberMasterList.length > 0) {
      const employeeData = this.SaleTeamMemberMasterList.find(emp => emp.EmployeeCode === data.EmpCode);
      if (employeeData) {
        // Use the full employee name from the original data
        this.currentEmpName = employeeData.EmployeeName;
        this.currentEmpCode = employeeData.EmployeeCode;
      } else {
        // Fallback to the shortened name if full name is not found
        this.currentEmpName = data.EmpName;
        this.currentEmpCode = data.EmpCode;
      }
    } else {
      this.currentEmpName = data.EmpName;
      this.currentEmpCode = data.EmpCode;
    }

    this.currentEmpTotalDeal = data.TeamTotalDeal

    // Filter sale team details by EmployeeCode
    var listTotal = this.ListTotalSaleTeamDetails.filter((x) => { return x.EmployeeCode == data.EmpCode });
    this.SettingGoogleChartDataSetFormat(listTotal, data.EmpCode, data.TeamColor);
    var currentMonth = this.ListMonth.indexOf(this.CurrentMonth) + 1;
    currentMonth = currentMonth.toString().padStart(2, '0');

    // Update ListSaleTeamDetails with filtered data
    this.ListSaleTeamDetails = listTotal.filter((x) => { return x.ProjectSaleCloseDealCreateDate.includes(this.CurrentYear + '-' + currentMonth) });

    // Make sure we keep the original team data in the ListTeamRank
    // This ensures the progress bars will still work
    if (this.ListTeamRank && this.ListTeamRank.length > 0) {
      // Find the index of the current employee in ListTeamRank
      const teamRankIndex = this.ListTeamRank.findIndex(t => t.EmpCode === data.EmpCode);
      if (teamRankIndex >= 0) {
        // Keep the original team data in ListTeamRank
        this.ListTeamRank[teamRankIndex] = originalTeamData;
      }
    }

    this.SetTotalpagePagination(this.ListSaleTeamDetails.length);

    // Filter pipeline data by ProjectPipelineCreateBy matching the selected employee's EmpCode
    if (this.ListProjectPipeline && this.ListProjectPipeline.length > 0) {
      // Create a filtered copy of the pipeline data from the original data
      const filteredPipelines = this._originalPipelineData.filter(pipeline => {
        return pipeline.ProjectPipelineCreateBy === data.EmpCode;
      });

      // Update the pipeline data with the filtered list
      this.ListProjectPipeline = filteredPipelines;

      // Update the pipeline charts and counts after filtering
      this.getPipelineStatusCounts();
      // Reinitialize the chart data with filtered pipelines
      this.initializePipelineChartData();
    }
  }
  async OnSalePerson_BackClick(reloadData: boolean = true) {
    this.IsSalePersonView = false;

    // Restore original pipeline data if it exists
    if (this._originalPipelineData) {
      this.ListProjectPipeline = this._originalPipelineData;
      this._originalPipelineData = null;
      this.getPipelineStatusCounts();
      // Reinitialize the chart data with original pipelines
      this.initializePipelineChartData();
    }

    // Restore original sale team details if it exists
    if (this._originalSaleTeamDetails) {
      this.ListSaleTeamDetails = this._originalSaleTeamDetails;
      this._originalSaleTeamDetails = null;
    }

    // Restore original team rank if it exists
    if (this._originalTeamRank) {
      this.ListTeamRank = this._originalTeamRank;
      this._originalTeamRank = null;
    }

    if (reloadData) {
      this.currentPageNumber = 1;
      await this.LoadListProjectCloseDealSummary();
      await this.OnLoadCountProjectCloseDealSummary();
    }
  }


  async LoadSaleTeam(condition: string) {

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['EmployeeCode'] = this.checkUndefinedString(this._EmpCode);

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamList = data;

          if (condition == "Initial") {
            if (this.SaleTeamList.length > 0) {
              this._ParamTeamCode = this.SaleTeamList[0].SaleTeamCode;
              this.OnTeamChanges();
            }
          }

          //console.log(this.SaleTeamList);
        });
    }
  }

  async LoadSaleTeamMaster() {

    this.SaleTeamMemberMasterList = [];

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['SaleTeamCode'] = this.checkUndefinedString(this._ParamTeamCode);
      // objectjson['EmployeesUnder'] = this.checkUndefinedString(this._EmpCode);
      objectjson['AssignedSellerOnly'] = true;

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SaleTeamMemberMasterList = data.filter(x => x.IsSaleTarget);

          //console.log(this.SaleTeamMemberMasterList)
        });
    }
  }

  async LoadSaleConversionRate(): Promise<any> {

    this.ListSaleConversionRate = [];

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      objectjson['SaleTargetTeamCode'] = this.checkUndefinedString(this._ParamTeamCode);
      objectjson['SaleTargetYear'] = this.checkUndefinedString(this.ddlYear);

      let strjson = JSON.stringify(objectjson);

      return new Promise((resolve, reject) => {
        this.httpClient.post<SaleConversionRateInfo[]>(this.baseurl + "Dashboard/GetSaleConversionRate", strjson, httpOptions)
          .toPromise()
          .then((data) => {
            try {
              this.ListSaleConversionRate = data;

              // Set the selected team name if we have a team code
              if (this._ParamTeamCode) {
                const team = this.SaleTeamList.find(t => t.SaleTeamCode === this._ParamTeamCode);
                this.SelectedTeamName = team ? team.SaleTeamName : '';
              }
              
              resolve(data);
            } catch (error) {
              console.error('Error processing conversion rate data:', error);
              reject(error);
            } finally {
              this.isLoadingSaleConversionRate = false;
              console.timeEnd("LoadSaleConversionRate");
            }
          })
          .catch(error => {
            this.isLoadingSaleConversionRate = false;
            console.timeEnd("LoadSaleConversionRate");
            console.error('Error loading sale conversion rate:', error);
            reject(error);
          });
      });
    }
    return Promise.resolve([]); // Return empty array if no auth token
  }

  async LoadProjectPipelineList(): Promise<any> {

    this.ListProjectPipeline = [];
    this._teamPipelineData = [];

    
    // Arrays to store precomputed pipeline data
    this.monthlyPipelineData = [];
    this.quarterlyPipelineData = [];
    this.monthlyPipelineCounts = [];
    this.quarterlyPipelineCounts = [];

    // Team Level Data
    this._teamPipelineData = [];
    this.teamRegularStatuses = [];
    this.teamClosedStatuses = [];
    this.teamSpecialStatuses = [];
    this.teamIndependentStatuses = [];

    // Properties to store filtered status counts
    this.regularStatuses = [];
    this.closedStatuses = [];
    this.specialStatuses = [];
    this.independentStatuses = [];

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };






      // If no month is selected (All), show full year data
      var startDate: Date;
      var endDate: Date;

      if (this.ChartType == "Month") {
        if (this.ddlMonth === null) {
          // For "All" month, show entire year
          startDate = new Date(this.CurrentYear, 0, 1); // January 1st
          endDate = new Date(this.CurrentYear, 11, 31, 23, 59); // December 31st 23:59
        } else {
          // For specific month
          var d = new Date('01-' + this.CurrentMonth + this.CurrentYear);
          var days = new Date(this.CurrentYear, (d.getMonth() + 1), 0).getDate();
          startDate = d;
          endDate = new Date(days + '-' + this.CurrentMonth + this.CurrentYear);
        }
      } else if (this.ChartType == "Quarter") {
        // Quarter view logic
        if (!this.ddlQuarter) {
          // For "All" quarters, show entire year
          startDate = new Date(this.CurrentYear, 0, 1); // January 1st
          endDate = new Date(this.CurrentYear, 11, 31, 23, 59); // December 31st 23:59
        } else {
          // For specific quarter
          var quarter = parseInt(this.ddlQuarter);
          var startMonth = (quarter - 1) * 3; // First month of the quarter
          var endMonth = startMonth + 2; // Last month of the quarter

          // Start date is first day of first month of the quarter
          startDate = new Date(this.CurrentYear, startMonth, 1);

          // End date is last day of last month of the quarter
          var lastDay = new Date(this.CurrentYear, endMonth + 1, 0).getDate();
          endDate = new Date(this.CurrentYear, endMonth, lastDay, 23, 59, 59);
        }
      }

      var objectjson = {};

      objectjson['ProjectPipelineFlagDelete'] = "N";
      objectjson['ProjectPipelineSaleTeamCode'] = this.checkUndefinedString(this._ParamTeamCode);
      objectjson['ProjectPipelineCustomFilter'] = "LATESTONLY"; //lookup closed

      objectjson['StartDate'] = startDate.toLocaleDateString('en-CA');
      objectjson['EndDate'] = endDate.toLocaleDateString('en-CA');

      let strjson = JSON.stringify(objectjson);

      return new Promise((resolve, reject) => {
        this.httpClient.post<ProjectPipelineInfo[]>(this.baseurl + "Dashboard/GetDashboardProjectPipeline", strjson, httpOptions)
          .toPromise()
          .then((data) => {
            try {
              this.ListProjectPipeline = data;

              // Store the team pipeline data for use in status section
              this._teamPipelineData = [...data];

              // Update the status arrays after loading pipeline data
              this.getPipelineStatusCounts();
              this.initializePipelineChartData();
              
              resolve(data);
            } catch (error) {
              console.error('Error processing pipeline data:', error);
              reject(error);
            } finally {
              this.isLoadingSaleProjectPipeline = false;
              console.timeEnd("LoadProjectPipelineList");
            }
          })
          .catch(error => {
            this.isLoadingSaleProjectPipeline = false;
            console.timeEnd("LoadProjectPipelineList");
            console.error('Error loading project pipeline:', error);
            reject(error);
          });
      });
    }
    
    return Promise.resolve([]); // Return empty array if no auth token
  }

  // Initialize pipeline chart data for both monthly and quarterly views
  initializePipelineChartData() {
    if (!this.ListProjectPipeline) {
      return;
    }

    // Initialize arrays with empty data
    this.monthlyPipelineData = Array(12).fill(null).map(() => ({
      labels: ['No Data'],
      data: [1],
      colors: ['#e0e0e0']
    }));

    this.quarterlyPipelineData = Array(4).fill(null).map(() => ({
      labels: ['No Data'],
      data: [1],
      colors: ['#e0e0e0']
    }));

    this.monthlyPipelineCounts = Array(12).fill(0);
    this.quarterlyPipelineCounts = Array(4).fill(0);

    // Process monthly data
    for (let i = 0; i < this.months.length; i++) {
      this.monthlyPipelineData[i] = this.getPipelineDataForMonth(i);
      this.monthlyPipelineCounts[i] = this.getPipelineCountForMonth(i);
    }

    // Process quarterly data
    for (let i = 0; i < this.quarters.length; i++) {
      this.quarterlyPipelineData[i] = this.getPipelineDataForQuarter(i + 1);
      this.quarterlyPipelineCounts[i] = this.getPipelineCountForQuarter(i + 1);
    }
  }

  async LoadSaleTarget(search: boolean = false): Promise<any> {
    this.ListSaleTarget = [];

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      //objectjson['RequesterEmpCode'] = this.checkUndefinedString(this._EmpCode);
      objectjson['SaleTargetTeamCode'] = this.checkUndefinedString(this._ParamTeamCode);
      // objectjson['SaleTargetEmpCode'] = this.checkUndefinedString(this.txtSearchSaleTeamMember);
      objectjson['SaleTargetMonth'] = this.checkUndefinedString(this.ddlMonth);
      objectjson['SaleTargetQuarter'] = this.checkUndefinedString(this.ddlQuarter != null ? "Q" + this.ddlQuarter : this.ddlQuarter);
      objectjson['SaleTargetYear'] = this.checkUndefinedString(this.ddlYear);

      let strjson = JSON.stringify(objectjson);

      return this.httpClient.post<SaleTargetInfo[]>(this.baseurl + "SaleTarget/GetSaleTargetList", strjson, httpOptions)
        .toPromise()
        .then((data) => {
          this.ListSaleTarget = data;
          this.isLoadingSaleTarget = false;
          console.timeEnd("LoadSaleTarget");
          return data;
        });
    }

    return Promise.resolve(null);
  }

  //Pie Chart
  OnChartClicked(traget) {

  }

  //Column Chart
  async onTypeOverallClick(chartType: string) {

    if (chartType == 'Month') {
      this.ChartType = "Month";
      this.ddlQuarter = null;
    } else {
      this.ChartType = "Quarter";
      this.ddlMonth = null;
    }

    //await this.RefreshDashboard();
  }
  SettingGoogleChartDataSetFormat(data: SaleTeamManagementsInfo[], empCode: string = "", color: string = "") {
    var viewType = this.ChartType; //1 = Month or 2 = quarter
    var arrParent = [];
    var hasData = false;



    // Placeholder generation
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];

    // Create placeholder data structure
    const placeholderData = [];
    const placeholderColors = [];

    // Add header row
    placeholderData.push([this.ChartType, 'Data']);

    // Add placeholder data for each month/quarter
    const periods = viewType === 'Month' ? months : quarters;
    for (let i = 0; i < periods.length; i++) {
      placeholderData.push([periods[i], 0]);
      placeholderColors.push(this.ListColor[i % this.ListColor.length]); // Cycle through available colors
    }

    this.ColorsPlaceholder = JSON.stringify(placeholderColors);
    this.DataSetsPlaceholder = JSON.stringify(placeholderData);







    // Reset data sets
    this.DataSets = JSON.stringify([]);
    this.Colors = JSON.stringify([]);

    //First row : define chart labels
    var groupEmps = this.GroupArrayOfObjects(data, "EmployeeCode");
    if (Object.keys(groupEmps).length > 0) {
      // Always add at least one column for months
      var tmp1stRowArr = [viewType, "Data"];
      if (!!empCode) {
        var lst = groupEmps[empCode];
        var empNameArr = lst[0].EmpName.split(' ');
        tmp1stRowArr.push(empNameArr[0] + ' ' + (empNameArr.length > 1 ? empNameArr[1].substr(0, 1) + '.' : ''));
      } else {
        for (var i in groupEmps) {
          var lst = groupEmps[i];
          var empNameArr = lst[0].EmpName.split(' ');
          tmp1stRowArr.push(empNameArr[0] + ' ' + (empNameArr.length > 1 ? empNameArr[1].substr(0, 1) + '.' : ''));
        }
      }
      arrParent.push(tmp1stRowArr);
    }

    var items = data;
    var that = this;

    if (this.ChartType == "Month") {
      //Month
      var listMonthsNumber = [];

      // Case 1: Year only - Show all months
      if (!this.ddlMonth) {
        for (var j = 1; j <= 12; j++) {
          var d2 = new Date(this.CurrentYear, j - 1, 1);
          listMonthsNumber.push(d2.toLocaleDateString('en-CA'));
        }
      }
      // Case 2: Year and Month - Show current month and 5 previous months
      else {
        var currentMonth = parseInt(this.ddlMonth);
        for (var j = 0; j < 4; j++) {
          var monthToAdd = currentMonth - j;
          var yearToUse = this.CurrentYear;

          // Handle previous year if needed
          if (monthToAdd <= 0) {
            monthToAdd += 12;
            yearToUse--;
          }

          var d2 = new Date(yearToUse, monthToAdd - 1, 1);
          listMonthsNumber.push(d2.toLocaleDateString('en-CA'));
        }
        listMonthsNumber = listMonthsNumber.reverse(); // Show from oldest to newest
      }

      //## chart data sets ##
      listMonthsNumber.forEach((_date) => {
        var arrChild = [];
        var d = new Date(_date);
        var _dateEnd = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
        var _txtDateEnd = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + _dateEnd;
        var fulteredDate = items.filter((x) => {
          return (new Date(x.ProjectSaleCloseDealCreateDate) >= new Date(_date) &&
            new Date(x.ProjectSaleCloseDealCreateDate) <= new Date(_txtDateEnd))
        });

        // Always add the month name and a default value
        arrChild.push((that.ListMonth[d.getMonth()]).substr(0, 3), 0);

        if (!!empCode) {
          var projsOfTeam = fulteredDate.filter((x) => { return x.EmployeeCode == empCode });
          var sumProjPrice = projsOfTeam.reduce((accumulator, current) => accumulator + current.ProjectSaleActualPrice, 0);
          if (sumProjPrice > 0) hasData = true;
          arrChild.push(sumProjPrice);
        } else {
          for (var key in groupEmps) {
            var projsOfTeam = fulteredDate.filter((x) => { return x.EmployeeCode == key });
            var sumProjPrice = projsOfTeam.reduce((accumulator, current) => accumulator + current.ProjectSaleActualPrice, 0);
            if (sumProjPrice > 0) hasData = true;
            arrChild.push(sumProjPrice);
          }
        }

        arrParent.push(arrChild);
      });

      if (arrParent.length > 1) {
        this.DataSets = JSON.stringify(arrParent);
        this.Colors = JSON.stringify(!!empCode ? [color] : this.ListColor.slice(0, Object.keys(groupEmps).length));
      }
    }
    else {
      // Quarter view
      if (!this.ddlQuarter) {
        // Case 1: Show all quarters
        var listQuarter = [
          { start: this.CurrentYear + '-01-01', end: this.CurrentYear + '-03-31' },
          { start: this.CurrentYear + '-04-01', end: this.CurrentYear + '-06-30' },
          { start: this.CurrentYear + '-07-01', end: this.CurrentYear + '-09-30' },
          { start: this.CurrentYear + '-10-01', end: this.CurrentYear + '-12-31' }
        ];

        listQuarter.forEach((_dateObj, idx) => {
          var arrChild = [];
          var fulteredDate = items.filter((x) => {
            return (new Date(x.ProjectSaleCloseDealCreateDate) >= new Date(_dateObj.start) &&
              new Date(x.ProjectSaleCloseDealCreateDate) <= new Date(_dateObj.end))
          });

          arrChild.push("Quarter " + (idx + 1), 0);

          if (!!empCode) {
            var projsOfTeam = fulteredDate.filter((x) => { return x.EmployeeCode == empCode });
            var sumProjPrice = projsOfTeam.reduce((accumulator, current) => accumulator + current.ProjectSaleActualPrice, 0);
            if (sumProjPrice > 0) hasData = true;
            arrChild.push(sumProjPrice);
          } else {
            for (var key in groupEmps) {
              var projsOfTeam = fulteredDate.filter((x) => { return x.EmployeeCode == key });
              var sumProjPrice = projsOfTeam.reduce((accumulator, current) => accumulator + current.ProjectSaleActualPrice, 0);
              if (sumProjPrice > 0) hasData = true;
              arrChild.push(sumProjPrice);
            }
          }

          arrParent.push(arrChild);
        });
      } else {
        // Case 3: Show 4 months of selected quarter
        var currentQuarter = parseInt(this.ddlQuarter);
        var startMonth = (currentQuarter - 1) * 3 + 1;

        // Switch to month view for quarter detail
        viewType = "Month";
        arrParent[0][0] = viewType;

        for (var j = 0; j < 3; j++) {
          var d2 = new Date(this.CurrentYear, startMonth - 1 + j, 1);
          var _date = d2.toLocaleDateString('en-CA');
          var arrChild = [];
          var _dateEnd = new Date(d2.getFullYear(), d2.getMonth() + 1, 0).getDate();
          var _txtDateEnd = d2.getFullYear() + '-' + (d2.getMonth() + 1) + '-' + _dateEnd;

          var fulteredDate = items.filter((x) => {
            return (new Date(x.ProjectSaleCloseDealCreateDate) >= new Date(_date) &&
              new Date(x.ProjectSaleCloseDealCreateDate) <= new Date(_txtDateEnd))
          });

          arrChild.push((that.ListMonth[d2.getMonth()]).substr(0, 3), 0);

          if (!!empCode) {
            var projsOfTeam = fulteredDate.filter((x) => { return x.EmployeeCode == empCode });
            var sumProjPrice = projsOfTeam.reduce((accumulator, current) => accumulator + current.ProjectSaleActualPrice, 0);
            if (sumProjPrice > 0) hasData = true;
            arrChild.push(sumProjPrice);
          } else {
            for (var key in groupEmps) {
              var projsOfTeam = fulteredDate.filter((x) => { return x.EmployeeCode == key });
              var sumProjPrice = projsOfTeam.reduce((accumulator, current) => accumulator + current.ProjectSaleActualPrice, 0);
              if (sumProjPrice > 0) hasData = true;
              arrChild.push(sumProjPrice);
            }
          }

          arrParent.push(arrChild);
        }
      }

      if (arrParent.length > 1) {
        this.DataSets = JSON.stringify(arrParent);
        this.Colors = JSON.stringify(!!empCode ? [color] : this.ListColor.slice(0, Object.keys(groupEmps).length));
      }
    }
  }

  //Pagination
  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
    }

    this.LoadListProjectCloseDealSummary();
  }
  OnLoadCountProjectCloseDealSummary() {
    this.LoadCountProjectCloseDealSummary().then(data => {
      this.SetTotalpagePagination(data);
    });
  }
  SetTotalpagePagination(data) {
    this.totalClosedDeal = data;
    if (this.totalClosedDeal == 0) {
      this.currentPageNumber = 0;
    } else {
      this.currentPageNumber = 1;
    }
    this.totalPages = Math.ceil(this.totalClosedDeal / environment.PageSize);
  }

  //Loading
  Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  GroupArrayOfObjects(list, key) {
    return list.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }
  CheckLeadFlag() {
    var empRank = this.ListTeamRank.filter((x) => { return x.EmpCode == this._EmpCode });
    if (empRank.length > 0) {
      this.currentRank = this.ListTeamRank.findIndex(x => x.EmpCode == this._EmpCode) + 1;
      this.currentColor = empRank[0].TeamColor;
      this.currentEmpName = empRank[0].EmpName;
      this.currentEmpCode = empRank[0].EmpCode;
      this.currentEmpTotalDeal = empRank[0].TeamTotalDeal
    } else {
      this.currentRank = 0;
      this.currentColor = "#cccccc";
      this.currentEmpName = localStorage.getItem("EmpName_TH");
      this.currentEmpTotalDeal = "0"
    }
  }

  GetTargetAmount(team: any): number {
    if (!this.ListSaleTarget || this.ListSaleTarget.length === 0) return 0;

    let quarterValue = this.ddlQuarter;
    if (this.ChartType == 'Quarter' && this.ddlQuarter != null) {
      // Remove Q prefix if it exists
      quarterValue = ("Q" + this.ddlQuarter).toString();
    }

    const target = this.ListSaleTarget.find(t =>
      t.SaleTargetTeamCode === team.TeamCode &&
      t.SaleTargetEmpCode === team.EmpCode &&
      t.SaleTargetMonth === this.ddlMonth &&
      t.SaleTargetQuarter === quarterValue &&
      t.SaleTargetYear === this.ddlYear
    );

    return target ? target.SaleTargetAmount : 0;
  }

  CalculateTargetProgress(team: any): number {
    const targetAmount = this.GetTargetAmount(team);

    if (targetAmount === 0) return 100; // If no target found, show 100%

    const percentage = (team.TeamTotalDeal / targetAmount) * 100;
    //return Math.min(100, Math.max(0, percentage)); // Clamp between 0 and 100
    return Math.max(0, percentage); // Only clamp to 0 minimum
  }

  GetTargetAmountNewCustomer(team: any): number {
    if (!this.ListSaleTarget || this.ListSaleTarget.length === 0) return 0;

    let quarterValue = this.ddlQuarter;
    if (this.ChartType == 'Quarter' && this.ddlQuarter != null) {
      quarterValue = ("Q" + this.ddlQuarter).toString();
    }

    const target = this.ListSaleTarget.find(t =>
      t.SaleTargetTeamCode === team.TeamCode &&
      t.SaleTargetEmpCode === team.EmpCode &&
      t.SaleTargetMonth === this.ddlMonth &&
      t.SaleTargetQuarter === quarterValue &&
      t.SaleTargetYear === this.ddlYear &&
      t.SaleTargetFlagNewCust === 'Y'
    );

    return target ? target.SaleTargetAmount : 0;
  }

  GetTargetAmountOldCustomer(team: any): number {
    if (!this.ListSaleTarget || this.ListSaleTarget.length === 0) return 0;

    let quarterValue = this.ddlQuarter;
    if (this.ChartType == 'Quarter' && this.ddlQuarter != null) {
      quarterValue = ("Q" + this.ddlQuarter).toString();
    }

    const target = this.ListSaleTarget.find(t =>
      t.SaleTargetTeamCode === team.TeamCode &&
      t.SaleTargetEmpCode === team.EmpCode &&
      t.SaleTargetMonth === this.ddlMonth &&
      t.SaleTargetQuarter === quarterValue &&
      t.SaleTargetYear === this.ddlYear &&
      t.SaleTargetFlagNewCust === 'N'
    );

    return target ? target.SaleTargetAmount : 0;
  }

  CalculateTargetProgressNewCustomer(team: any): number {
    const targetAmount = this.GetTargetAmountNewCustomer(team);
    if (targetAmount === 0) return 100; // If no target found, show 100%

    // Use original data if available (when in person view), otherwise use current data
    const dataToUse = this.IsSalePersonView && this._originalSaleTeamDetails ?
      this._originalSaleTeamDetails : this.ListSaleTeamDetails;

    // Filter deals for new customers using the team's deals
    const newCustomerDeals = dataToUse.filter(deal =>
      deal.EmployeeCode === team.EmpCode &&
      deal.CompanyFlagNew === 'Y'
    );

    const totalNewCustomerAmount = newCustomerDeals.reduce((sum, deal) => sum + (deal.ProjectSaleActualPrice || 0), 0);
    const percentage = (totalNewCustomerAmount / targetAmount) * 100;
    return Math.max(0, percentage); // Only clamp to 0 minimum
  }

  CalculateTargetProgressOldCustomer(team: any): number {
    const targetAmount = this.GetTargetAmountOldCustomer(team);
    if (targetAmount === 0) return 100; // If no target found, show 100%

    // Use original data if available (when in person view), otherwise use current data
    const dataToUse = this.IsSalePersonView && this._originalSaleTeamDetails ?
      this._originalSaleTeamDetails : this.ListSaleTeamDetails;

    // Filter deals for old customers using the team's deals
    const oldCustomerDeals = dataToUse.filter(deal =>
      deal.EmployeeCode === team.EmpCode &&
      deal.CompanyFlagNew === 'N'
    );

    const totalOldCustomerAmount = oldCustomerDeals.reduce((sum, deal) => sum + (deal.ProjectSaleActualPrice || 0), 0);
    const percentage = (totalOldCustomerAmount / targetAmount) * 100;
    return Math.max(0, percentage); // Only clamp to 0 minimum
  }

  CalculateAmountLeft(team: any): number {
    const targetAmount = this.GetTargetAmount(team);
    const remaining = targetAmount - team.TeamTotalDeal;
    return remaining > 0 ? remaining : 0;
  }

  CalculateAmountLeftNewCustomer(team: any): number {
    const targetAmount = this.GetTargetAmountNewCustomer(team);

    // Use original data if available (when in person view), otherwise use current data
    const dataToUse = this.IsSalePersonView && this._originalSaleTeamDetails ?
      this._originalSaleTeamDetails : this.ListSaleTeamDetails;

    // Calculate total amount for new customers
    const newCustomerDeals = dataToUse.filter(deal =>
      deal.EmployeeCode === team.EmpCode &&
      deal.CompanyFlagNew === 'Y'
    );

    const totalNewCustomerAmount = newCustomerDeals.reduce((sum, deal) => sum + (deal.ProjectSaleActualPrice || 0), 0);
    const remaining = targetAmount - totalNewCustomerAmount;
    return remaining > 0 ? remaining : 0;
  }

  CalculateAmountLeftOldCustomer(team: any): number {
    const targetAmount = this.GetTargetAmountOldCustomer(team);

    // Use original data if available (when in person view), otherwise use current data
    const dataToUse = this.IsSalePersonView && this._originalSaleTeamDetails ?
      this._originalSaleTeamDetails : this.ListSaleTeamDetails;

    // Calculate total amount for old customers
    const oldCustomerDeals = dataToUse.filter(deal =>
      deal.EmployeeCode === team.EmpCode &&
      deal.CompanyFlagNew === 'N'
    );

    const totalOldCustomerAmount = oldCustomerDeals.reduce((sum, deal) => sum + (deal.ProjectSaleActualPrice || 0), 0);
    const remaining = targetAmount - totalOldCustomerAmount;
    return remaining > 0 ? remaining : 0;
  }

  getChartLabels(): string[] {
    return ['Win', 'Loss', 'Pending'];
  }

  getPercentageLabel(index: number): string {
    const amounts = this.getConversionAmounts();
    const total = amounts.win + amounts.loss + amounts.pending;
    const values = [amounts.win, amounts.loss, amounts.pending];

    return total > 0 ? ((values[index] / total) * 100).toFixed(1) + '%' : '0%';
  }

  getConversionAmounts(): { win: number, loss: number, pending: number } {
    if (!this.ListSaleConversionRate) return { win: 0, loss: 0, pending: 0 };

    const amounts = {
      win: 0,
      loss: 0,
      pending: 0
    };

    this.ListSaleConversionRate.forEach(rate => {
      amounts.win += rate.Win;
      amounts.loss += rate.Loss;
      amounts.pending += rate.Pending;
    });

    return amounts;
  }

  getConversionPercentages(): { win: number, loss: number, pending: number } {
    const amounts = this.getConversionAmounts();
    const total = amounts.win + amounts.loss + amounts.pending;

    return {
      win: total > 0 ? (amounts.win / total) * 100 : 0,
      loss: total > 0 ? (amounts.loss / total) * 100 : 0,
      pending: total > 0 ? (amounts.pending / total) * 100 : 0
    };
  }

  getChartColors(): string[] {
    return ['#92D050', '#D9958F', '#FEE599'];
  }

  updateChartColors(): void {
    const amounts = this.getConversionAmounts();
    this.chartColors[0].percentageLabels = [
      this.getPercentageLabel(0),
      this.getPercentageLabel(1),
      this.getPercentageLabel(2)
    ];
  }

  ngAfterViewInit() {
    this.updateChartColors();
  }

  getTotalLeadAmount(): number {
    if (!this.ListSaleConversionRate || this.ListSaleConversionRate.length === 0) return 0;

    return this.ListSaleConversionRate.reduce((total, item) => total + (item.TotalLead || 0), 0);
  }

  // Properties to store filtered status counts
  regularStatuses: any[] = [];
  closedStatuses: any[] = [];
  specialStatuses: any[] = [];
  independentStatuses: any[] = [];

  // Default status definitions
  defaultStatuses = {
    regular: [
      { LookupValue: 'Lead', LookupCode: '1', count: 0, amount: 0, color: '#205F9A', type: 'regular' },
      { LookupValue: 'Qualified Lead', LookupCode: '2', count: 0, amount: 0, color: '#4E94D9', type: 'regular' },
      { LookupValue: 'Prospect', LookupCode: '3', count: 0, amount: 0, color: '#A6C9EB', type: 'regular' },
      { LookupValue: 'Proposal / Quotation', LookupCode: '4', count: 0, amount: 0, color: '#C4DCF1', type: 'regular' },
      { LookupValue: 'Negotiation', LookupCode: '5', count: 0, amount: 0, color: '#D1ECFD', type: 'regular' },
      { LookupValue: 'Closed', LookupCode: '6', count: 0, amount: 0, color: '#E6F6FF', type: 'regular' }
    ],
    closed: [
      { LookupValue: 'Won', LookupCode: '6', count: 0, amount: 0, color: '#006B00', type: 'closed' },
      { LookupValue: 'Lost', LookupCode: '6', count: 0, amount: 0, color: '#990000', type: 'closed' }
    ],
    special: [
      { LookupValue: 'Suspended', LookupCode: '7', count: 0, amount: 0, color: '#C4DB12', type: 'special' },
      { LookupValue: 'Terminated', LookupCode: '8', count: 0, amount: 0, color: '#006FC0', type: 'special' }
    ],
    independent: [
      { LookupValue: 'Backlog', LookupCode: '9', count: 0, amount: 0, color: '#AEBE46', type: 'independent' },
      { LookupValue: 'New Business', LookupCode: '10', count: 0, amount: 0, color: '#E6F7C3', type: 'independent' }
    ]
  };

  getPipelineStatusCounts(): any[] {
    // Always use team data for the status section, regardless of salesperson view
    const pipelineData = this._teamPipelineData && this._teamPipelineData.length > 0 ?
      this._teamPipelineData : this.ListProjectPipeline;

    if (!pipelineData || !this.PipelineStatusList) return [];

    // Define an interface for the pipeline object to ensure type safety
    interface PipelineItem {
      ProjectSaleCode: string;
      ProjectPipelineStatusLookupCode: string;
      ProjectPipelineAmount: string;
      ProjectPipelineSubStateCode?: string;
      //ProjectSaleServiceDeliveryStatus?: string;
      ProjectSaleState?: string;
      ProjectSaleServiceDeliveryWaitingAmount?: string;
      ProjectSaleServiceDeliveryNewBusinessAmount?: string;
      ServiceDeliveryBacklogDetailListWaiting?: ServiceDeliveryBacklogDetailInfo[];
      ServiceDeliveryBacklogDetailListNewBusiness?: ServiceDeliveryBacklogDetailInfo[];
    }

    // First, group by ProjectSaleCode and get the highest status for each project
    const groupedByProject = pipelineData.reduce((acc, pipeline) => {
      if (!acc[pipeline.ProjectSaleCode]) {
        acc[pipeline.ProjectSaleCode] = pipeline;
      } else {
        // Update with higher status if found
        if (Number(pipeline.ProjectPipelineStatusLookupCode) > Number(acc[pipeline.ProjectSaleCode].ProjectPipelineStatusLookupCode)) {
          acc[pipeline.ProjectSaleCode] = pipeline;
        }
      }
      return acc;
    }, {} as { [key: string]: PipelineItem });

    // Get the array of highest status pipelines
    const highestStatusPipelines = Object.values(groupedByProject) as PipelineItem[];

    // Count statuses and calculate amounts
    const statusCounts: any[] = [];
    const statusMap = new Map<string, { count: number, amount: number }>();

    // Initialize statusMap with all possible status codes from PipelineStatusList
    this.PipelineStatusList.forEach(status => {
      statusMap.set(status.LookupCode, { count: 0, amount: 0 });
    });

    // Track special statuses separately
    let closedWonCount = 0;
    let closedWonAmount = 0;
    let closedLostCount = 0;
    let closedLostAmount = 0;
    let suspendedCount = 0;
    let suspendedAmount = 0;
    let terminatedCount = 0;
    let terminatedAmount = 0;
    let backlogCount = 0;
    let backlogAmount = 0;
    let newBusinessCount = 0;
    let newBusinessAmount = 0;

    //console.log(highestStatusPipelines)

    highestStatusPipelines.forEach(pipeline => {
      const status = pipeline.ProjectPipelineStatusLookupCode;
      const amount = parseFloat(pipeline.ProjectPipelineAmount) || 0;

      // Handle special statuses
      if (status === '6') { // Closed status
        if (pipeline.ProjectPipelineSubStateCode === '1-5-1') { // Closed Won
          closedWonCount++;
          closedWonAmount += amount;

          let backlogAmountTemp = parseFloat(pipeline.ProjectSaleServiceDeliveryWaitingAmount) || 0;
          let newBusinessAmountTemp = parseFloat(pipeline.ProjectSaleServiceDeliveryNewBusinessAmount) || 0;
          if (pipeline.ServiceDeliveryBacklogDetailListWaiting.length > 0) {
            backlogCount += pipeline.ServiceDeliveryBacklogDetailListWaiting.length;
            backlogAmount += backlogAmountTemp;
          }
          if (pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length > 0) {
            newBusinessCount += pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length;
            newBusinessAmount += newBusinessAmountTemp;
          }

        } else if (pipeline.ProjectPipelineSubStateCode === '1-5-2') { // Closed Lost
          closedLostCount++;
          closedLostAmount += amount;
        } else if (pipeline.ProjectPipelineSubStateCode === '1-5-1-PLACEHOLDER') {
          let backlogAmountTemp = parseFloat(pipeline.ProjectSaleServiceDeliveryWaitingAmount) || 0;
          let newBusinessAmountTemp = parseFloat(pipeline.ProjectSaleServiceDeliveryNewBusinessAmount) || 0;
          if (pipeline.ServiceDeliveryBacklogDetailListWaiting.length > 0) {
            backlogCount += pipeline.ServiceDeliveryBacklogDetailListWaiting.length;
            backlogAmount += backlogAmountTemp;
          }
          if (pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length > 0) {
            newBusinessCount += pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length;
            newBusinessAmount += newBusinessAmountTemp;
          }
        } else if (pipeline.ProjectSaleState === '1-9') { // Suspended
          suspendedCount++;
          suspendedAmount += amount;
        } else if (pipeline.ProjectSaleState === '0') { // Terminated
          terminatedCount++;
          terminatedAmount += amount;
        }
      } else { // Regular non-closed status
        if (statusMap.has(status)) {
          const current = statusMap.get(status);
          statusMap.set(status, {
            count: current.count + 1,
            amount: current.amount + amount
          });
        }
      }
    });

    // Format the counts for non-closed statuses - include all statuses regardless of count
    const nonClosedStatusList = this.PipelineStatusList.filter(s => s.LookupCode !== '6');
    nonClosedStatusList.forEach(status => {
      const data = statusMap.get(status.LookupCode) || { count: 0, amount: 0 };
      // Find the matching default status to get the correct color
      const defaultStatus = this.defaultStatuses.regular.find(s => s.LookupCode === status.LookupCode);
      statusCounts.push({
        LookupCode: status.LookupCode,
        LookupValue: status.LookupValue,
        count: data.count,
        amount: data.amount,
        color: defaultStatus ? defaultStatus.color : this.getStatusColor(status.LookupCode),
        type: 'regular'
      });
    });

    // Add all statuses regardless of count
    // Closed statuses
    statusCounts.push({
      LookupCode: 'won',
      LookupValue: 'Won',
      count: closedWonCount,
      amount: closedWonAmount,
      color: '#006B00', // Green color for won
      type: 'closed'
    });

    statusCounts.push({
      LookupCode: 'lost',
      LookupValue: 'Lost',
      count: closedLostCount,
      amount: closedLostAmount,
      color: '#FF0000', // Red color for lost
      type: 'closed'
    });

    // Special statuses
    statusCounts.push({
      LookupCode: 'suspended',
      LookupValue: 'Suspended',
      count: suspendedCount,
      amount: suspendedAmount,
      color: '#C4DB12', // Yellow color for suspended
      type: 'special'
    });

    statusCounts.push({
      LookupCode: 'terminated',
      LookupValue: 'Terminated',
      count: terminatedCount,
      amount: terminatedAmount,
      color: '#006FC0', // Gray color for terminated
      type: 'special'
    });

    // Independent statuses
    statusCounts.push({
      LookupCode: 'waiting',
      LookupValue: 'Backlog',
      count: backlogCount,
      amount: backlogAmount,
      color: '#AEBE46', // Info color for backlog
      type: 'independent'
    });

    statusCounts.push({
      LookupCode: 'new-business',
      LookupValue: 'New Business',
      count: newBusinessCount,
      amount: newBusinessAmount,
      color: '#E6F7C3', // Primary color for new business
      type: 'independent'
    });

    // Merge actual data with defaults to ensure all statuses are shown
    // Create maps to quickly look up actual data by status name
    const regularDataMap = new Map(statusCounts.filter(s => s.type === 'regular')
      .map(status => [status.LookupValue, status]));
    const closedDataMap = new Map(statusCounts.filter(s => s.type === 'closed')
      .map(status => [status.LookupValue, status]));
    const specialDataMap = new Map(statusCounts.filter(s => s.type === 'special')
      .map(status => [status.LookupValue, status]));
    const independentDataMap = new Map(statusCounts.filter(s => s.type === 'independent')
      .map(status => [status.LookupValue, status]));

    // Merge defaults with actual data
    this.regularStatuses = this.defaultStatuses.regular.map(defaultStatus => {
      const actualStatus = regularDataMap.get(defaultStatus.LookupValue);
      return actualStatus || defaultStatus;
    });

    this.closedStatuses = this.defaultStatuses.closed.map(defaultStatus => {
      const actualStatus = closedDataMap.get(defaultStatus.LookupValue);
      return actualStatus || defaultStatus;
    });

    this.specialStatuses = this.defaultStatuses.special.map(defaultStatus => {
      const actualStatus = specialDataMap.get(defaultStatus.LookupValue);
      return actualStatus || defaultStatus;
    });

    this.independentStatuses = this.defaultStatuses.independent.map(defaultStatus => {
      const actualStatus = independentDataMap.get(defaultStatus.LookupValue);
      return actualStatus || defaultStatus;
    });

    // If we're not in salesperson view or this is the first time calculating statuses,
    // store the team-level statuses
    if (!this.IsSalePersonView || !this.teamRegularStatuses.length) {
      this.teamRegularStatuses = [...this.regularStatuses];
      this.teamClosedStatuses = [...this.closedStatuses];
      this.teamSpecialStatuses = [...this.specialStatuses];
      this.teamIndependentStatuses = [...this.independentStatuses];
    }

    return statusCounts;
  }

  calculateFrontlogTotalValue(month?: number, quarter?: number): number {
    // Always use team data for this section, regardless of salesperson view
    const pipelineData = this._teamPipelineData && this._teamPipelineData.length > 0 ?
      this._teamPipelineData : this.ListProjectPipeline;

    if (!pipelineData) return 0;

    // Filter pipelines by month or quarter if specified
    let filteredPipelines = [...pipelineData];

    if (month !== undefined) {
      // Filter by month
      filteredPipelines = filteredPipelines.filter(pipeline => {
        const pipelineDate = new Date(pipeline.ProjectSaleCreateDate);
        return pipelineDate.getMonth() === month && pipelineDate.getFullYear() === this.CurrentYear;
      });
    } else if (quarter !== undefined) {
      // Filter by quarter
      const startMonth = (quarter - 1) * 3;
      const endMonth = startMonth + 2;

      filteredPipelines = filteredPipelines.filter(pipeline => {
        const pipelineDate = new Date(pipeline.ProjectSaleCreateDate);
        const month = pipelineDate.getMonth();
        return month >= startMonth && month <= endMonth && pipelineDate.getFullYear() === this.CurrentYear;
      });
    }

    // Define an interface for the pipeline object to ensure type safety
    interface PipelineItem {
      ProjectSaleCode: string;
      ProjectPipelineStatusLookupCode: string;
      ProjectPipelineAmount: string;
      ProjectPipelineSubStateCode?: string;
      //ProjectSaleServiceDeliveryStatus?: string;
      ProjectSaleState?: string;
      ProjectSaleServiceDeliveryWaitingAmount?: string;
      ProjectSaleServiceDeliveryNewBusinessAmount?: string;
      ServiceDeliveryBacklogDetailListWaiting?: ServiceDeliveryBacklogDetailInfo[];
      ServiceDeliveryBacklogDetailListNewBusiness?: ServiceDeliveryBacklogDetailInfo[];
    }

    // Split pipelines into two groups: those with status codes 1-5 and others
    const pipelinesToGroup = filteredPipelines.filter(pipeline =>
      ['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );
    const otherPipelines = filteredPipelines.filter(pipeline =>
      !['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );

    // First, group by ProjectSaleCode and get the highest status for each project
    const groupedByProject = pipelinesToGroup.reduce((acc, pipeline) => {
      if (!acc[pipeline.ProjectSaleCode]) {
        acc[pipeline.ProjectSaleCode] = pipeline;
      } else {
        // Update with higher status if found
        if (Number(pipeline.ProjectPipelineStatusLookupCode) > Number(acc[pipeline.ProjectSaleCode].ProjectPipelineStatusLookupCode)) {
          acc[pipeline.ProjectSaleCode] = pipeline;
        }
      }
      return acc;
    }, {} as { [key: string]: PipelineItem });

    // Get the array of highest status pipelines
    const highestStatusPipelines = [...Object.values(groupedByProject), ...otherPipelines] as PipelineItem[];

    // Sum the amounts for statuses with LookupCode 1-5 (Frontlog statuses)
    // Only include pipelines that are in the filtered list and have status codes 1-5
    let totalAmount = 0;

    highestStatusPipelines.forEach(pipeline => {
      const status = pipeline.ProjectPipelineStatusLookupCode;
      const amount = parseFloat(pipeline.ProjectPipelineAmount) || 0;

      // Combine statuses 1-5 into Frontlog - only count if not Backlog or New Business
      if ((['1', '2', '3', '4', '5'].includes(status)) &&
        pipeline.ProjectPipelineSubStateCode != '1-5-1' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-2' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-1-PLACEHOLDER' &&
        pipeline.ProjectSaleState !== '1-9' &&
        pipeline.ProjectSaleState !== '0') {
        totalAmount += amount;
      }
    });

    return totalAmount;
  }

  calculateBacklogTotalValue(month?: number, quarter?: number): number {
    // Always use team data for this section, regardless of salesperson view
    const pipelineData = this._teamPipelineData && this._teamPipelineData.length > 0 ?
      this._teamPipelineData : this.ListProjectPipeline;

    if (!pipelineData) return 0;

    // Filter pipelines by month or quarter if specified
    let filteredPipelines = [...pipelineData];

    if (month !== undefined) {
      // Filter by month
      filteredPipelines = filteredPipelines.filter(pipeline => {
        const pipelineDate = new Date(pipeline.ProjectSaleCreateDate);
        return pipelineDate.getMonth() === month && pipelineDate.getFullYear() === this.CurrentYear;
      });
    } else if (quarter !== undefined) {
      // Filter by quarter
      const startMonth = (quarter - 1) * 3;
      const endMonth = startMonth + 2;

      filteredPipelines = filteredPipelines.filter(pipeline => {
        const pipelineDate = new Date(pipeline.ProjectSaleCreateDate);
        const month = pipelineDate.getMonth();
        return month >= startMonth && month <= endMonth && pipelineDate.getFullYear() === this.CurrentYear;
      });
    }

    // Sum the amounts for Backlog status
    let totalAmount = 0;

    filteredPipelines.forEach(pipeline => {
      if (pipeline.ProjectPipelineSubStateCode === '1-5-1') {
        // Add the pipeline amount to the total
        totalAmount += Number(pipeline.ProjectPipelineAmount) || 0;
      }
    });

    return totalAmount;
  }


  calculateBacklogSeparatedTotalValue(type: string): number {
    //type = 1 = waiting
    //type = 2 = new business



    // Always use team data for this section, regardless of salesperson view
    const pipelineData = this._teamPipelineData && this._teamPipelineData.length > 0 ?
      this._teamPipelineData : this.ListProjectPipeline;

    if (!pipelineData) return 0;

    // Filter pipelines by month or quarter if specified
    let filteredPipelines = [...pipelineData];

    // Sum the amounts for Backlog status
    let totalAmount = 0;

    if (type == '1') {
      filteredPipelines.forEach(pipeline => {
        if (pipeline.ProjectPipelineSubStateCode === '1-5-1') {
          // Add the pipeline amount to the total
          totalAmount += Number(pipeline.ProjectSaleServiceDeliveryWaitingAmount) || 0;
        }
      });
    }
    else if (type == '2') {
      filteredPipelines.forEach(pipeline => {
        if (pipeline.ProjectPipelineSubStateCode === '1-5-1') {
          // Add the pipeline amount to the total
          totalAmount += Number(pipeline.ProjectSaleServiceDeliveryNewBusinessAmount) || 0;
        }
      });
    }



    return totalAmount;
  }




  getFilteredPipelineCount(): number {
    if (!this.ListProjectPipeline) return 0;

    // First, group by ProjectSaleCode and get the highest status for each project
    const groupedByProject = this.ListProjectPipeline.reduce((acc, pipeline) => {
      if (!acc[pipeline.ProjectSaleCode]) {
        acc[pipeline.ProjectSaleCode] = pipeline;
      } else {
        // Update with higher status if found
        if (Number(pipeline.ProjectPipelineStatusLookupCode) > Number(acc[pipeline.ProjectSaleCode].ProjectPipelineStatusLookupCode)) {
          acc[pipeline.ProjectSaleCode] = pipeline;
        }
      }
      return acc;
    }, {} as { [key: string]: any });

    // Get the array of highest status pipelines
    const highestStatusPipelines = Object.values(groupedByProject);

    // Count pipelines where status is not 6 (closed)
    return highestStatusPipelines.filter(pipeline =>
      pipeline.ProjectPipelineStatusLookupCode !== '6'
    ).length;
  }

  getStatusColor(statusCode: string): string {
    switch (statusCode) {
      case '1': return '#FCEBDD';
      case '2': return '#D9958F';
      case '3': return '#7E649E';
      case '4': return '#00B0F0';
      case '5': return '#FEE599';
      case '6': return '#92D050'; // Default color for Closed status
      case '7': return '#8B4513'; // Brown for Suspended
      case '8': return '#444444'; // Dark Grey for Terminate
      default: return '#607D8B'; // Gray
    }
  }

  openPipelineDialog(monthIndex?: number, quarterIndex?: number): void {
    // Prepare date filters based on month or quarter
    let startDate: Date | null = null;
    let endDate: Date | null = null;
    let periodLabel = '';
    let viewAll = false;

    if (monthIndex !== undefined) {
      // Month-based filtering
      startDate = new Date(this.CurrentYear, monthIndex, 1);
      endDate = new Date(this.CurrentYear, monthIndex + 1, 0); // Last day of month
      periodLabel = this.months[monthIndex];
    } else if (quarterIndex !== undefined) {
      // Quarter-based filtering
      const startMonth = quarterIndex * 3; // 0-based index (Q1 = 0,1,2)
      const endMonth = startMonth + 2;
      startDate = new Date(this.CurrentYear, startMonth, 1);
      endDate = new Date(this.CurrentYear, endMonth + 1, 0); // Last day of last month in quarter
      periodLabel = `Q${quarterIndex + 1}`;
    } else {
      startDate = new Date(this.CurrentYear, 0, 1);
      endDate = new Date(this.CurrentYear, 11, 31);
    }

    if (this.IsSalePersonView == false) {
      viewAll = true;
    }

    // Format dates for API if they exist with specific times
    // Start date at 00:00:00
    if (startDate) startDate.setHours(0, 0, 0, 0);
    // End date at 23:59:59
    if (endDate) endDate.setHours(23, 59, 59, 999);

    // Format with ISO string and take the date part with time
    const formattedStartDate = startDate ? startDate.toISOString().split('.')[0] : null;
    const formattedEndDate = endDate ? endDate.toISOString().split('.')[0] : null;

    // Activate the fade overlay before opening the dialog
    this.dialogOpen = true;

    // Open the dialog with the appropriate filters after a short delay
    setTimeout(() => {
      const dialogRef = this.dialog.open(PipeLineComponent, {
        width: '80%',
        height: '90vh',
        data: {
          _ParamTeamCode: this._ParamTeamCode,
          _ParamTeamName: this.SelectedTeamName,
          FlagViewNotClosed: 'N',
          StartDate: formattedStartDate,
          EndDate: formattedEndDate,
          PeriodLabel: periodLabel,
          EmployeeCode: viewAll ? null : this.currentEmpCode
        }
      });

      //console.log(this.ListTeamRank);

      dialogRef.afterClosed().subscribe(result => {
        // Store the current state before reloading data
        // const wasSalePersonView = this.IsSalePersonView;
        // const currentEmpCode = this.currentEmpCode;

        //console.log('Dialog closed - Current state:', { wasSalePersonView, currentEmpCode });

        // Always reload the pipeline data first
        // this.LoadProjectPipelineList().then(() => {
        //   console.log('Pipeline data loaded:', this.ListProjectPipeline ? this.ListProjectPipeline.length : 0, 'records');

        //   // If we were in salesperson view, we need to restore that state
        //   if (wasSalePersonView && currentEmpCode) {
        //     console.log('Restoring salesperson view for employee code:', currentEmpCode);

        //     // Make sure we're still in salesperson view
        //     this.IsSalePersonView = true;

        //     // Store the newly loaded pipeline data as the original data
        //     if (this.ListProjectPipeline && this.ListProjectPipeline.length > 0) {
        //       // Save the full data as original
        //       this._originalPipelineData = [...this.ListProjectPipeline];

        //       // Check what fields are available for filtering
        //       if (this.ListProjectPipeline.length > 0) {
        //         console.log('Sample pipeline record fields:', Object.keys(this.ListProjectPipeline[0]));
        //         console.log('Sample record:', this.ListProjectPipeline[0]);
        //       }

        //       // Try both ProjectPipelineCreateBy and ProjectSaleCreateBy fields for filtering
        //       let filteredPipelines = this._originalPipelineData.filter(pipeline => {
        //         // Check if the pipeline was created by this employee
        //         const matchesCreateBy = pipeline.ProjectPipelineCreateBy === currentEmpCode;
        //         // Also check if the sale was created by this employee as a fallback
        //         const matchesSaleCreateBy = pipeline.ProjectSaleCreateBy === currentEmpCode;
        //         return matchesCreateBy || matchesSaleCreateBy;
        //       });

        //       console.log('Filtered pipelines count:', filteredPipelines.length, 'out of', this._originalPipelineData.length);

        //       // If we still don't have any results, try additional fields
        //       if (filteredPipelines.length === 0) {
        //         console.log('No matches found with primary fields, trying alternative fields');
        //         filteredPipelines = this._originalPipelineData.filter(pipeline => {
        //           // Try any other potential employee-related fields
        //           return pipeline.ProjectPipelineSearchSaleTeamEmpCode === currentEmpCode ||
        //                  pipeline.AllTeamMembersOfEmpCode?.includes(currentEmpCode);
        //         });
        //         console.log('Alternative field filtering results:', filteredPipelines.length);
        //       }

        //       // Update the pipeline data with the filtered list
        //       this.ListProjectPipeline = filteredPipelines;

        //       // Update the pipeline charts and counts after filtering
        //       this.getPipelineStatusCounts();
        //       this.initializePipelineChartData();
        //     }
        //   }

        //   // Fade out the overlay after a short delay
        //   setTimeout(() => {
        //     this.dialogOpen = false;
        //   }, 300);
        // });

        setTimeout(() => {
          this.dialogOpen = false;
        }, 300);
      });
    }, 300);
  }

  getConversionRate(): string {
    if (!this.ListSaleConversionRate) return '0%';

    const totalLead = this.getTotalLeadAmount();
    const win = this.ListSaleConversionRate.reduce((total, item) => total + (item.Win || 0), 0);

    return totalLead > 0 ?
      ((win / totalLead) * 100).toFixed(1) + '%' :
      '0%';
  }

  getWinAmount(): number {
    if (!this.ListSaleConversionRate || this.ListSaleConversionRate.length === 0) return 0;
    return this.ListSaleConversionRate.reduce((total, item) => total + (item.Win || 0), 0);
  }

  getLossAmount(): number {
    if (!this.ListSaleConversionRate || this.ListSaleConversionRate.length === 0) return 0;
    return this.ListSaleConversionRate.reduce((total, item) => total + (item.Loss || 0), 0);
  }

  getPendingAmount(): number {
    if (!this.ListSaleConversionRate || this.ListSaleConversionRate.length === 0) return 0;
    return this.ListSaleConversionRate.reduce((total, item) => total + (item.Pending || 0), 0);
  }

  onViewDetailsClick(): void {
    const dialogRef = this.dialog.open(ConversionRateDialogComponent, {
      width: '800px',
      data: {
        conversionRates: this.ListSaleConversionRate,
        teamName: this.SelectedTeamName,
        year: this.ddlYear
      }
    });
  }

  // Ring Chart options
  public ringChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    cutoutPercentage: 75,
    plugins: {
      datalabels: {
        display: false // นี่คือตัวที่สั่งให้ datalabels หยุดทำงาน
      }
    },
    tooltips: {
      enabled: false, // Disable default tooltips
      custom: function (tooltipModel) {
        // Tooltip Element
        let tooltipEl = document.getElementById('chartjs-tooltip');

        // Create element on first render
        if (!tooltipEl) {
          tooltipEl = document.createElement('div');
          tooltipEl.id = 'chartjs-tooltip';
          tooltipEl.innerHTML = '<div></div>';
          document.body.appendChild(tooltipEl);
        }

        // Hide if no tooltip
        if (tooltipModel.opacity === 0) {
          tooltipEl.style.opacity = '0';
          return;
        }

        // Set Text
        if (tooltipModel.body) {
          const titleLines = tooltipModel.title || [];
          const bodyLines = tooltipModel.body.map(function (bodyItem) {
            return bodyItem.lines;
          });

          let innerHtml = '<div class="tooltip-title">';

          // titleLines.forEach(function(title) {
          //   innerHtml += '<span>' + title + '</span>';
          // });

          innerHtml += '</div><div class="tooltip-body">';

          bodyLines.forEach(function (body, i) {
            innerHtml += '<span>' + body + '</span>';
          });
          innerHtml += '</div>';

          const tooltipRoot = tooltipEl.querySelector('div');
          tooltipRoot.innerHTML = innerHtml;
        }

        // Position tooltip and set styles
        const position = this._chart.canvas.getBoundingClientRect();

        // Set tooltip styles - IMPORTANT: position absolute and z-index 999999 to be above everything
        tooltipEl.style.opacity = '1';
        tooltipEl.style.position = 'fixed'; // Use fixed instead of absolute for better positioning
        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY - 80 + 'px'; // Move higher up
        tooltipEl.style.fontFamily = 'Arial, Helvetica, sans-serif';
        tooltipEl.style.fontSize = '14px';
        tooltipEl.style.fontStyle = 'normal';
        tooltipEl.style.padding = '10px';
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
        tooltipEl.style.color = '#fff';
        tooltipEl.style.borderRadius = '5px';
        tooltipEl.style.zIndex = '999999'; // Extremely high z-index
        tooltipEl.style.boxShadow = '0 2px 5px rgba(0,0,0,0.2)';
        tooltipEl.style.minWidth = '120px';
        tooltipEl.style.textAlign = 'center';
      },
      callbacks: {
        // These callbacks are still needed for the custom tooltip
        label: (tooltipItem, data) => {
          const dataset = data.datasets[tooltipItem.datasetIndex];
          const currentValue = dataset.data[tooltipItem.index];
          const label = data.labels[tooltipItem.index];

          // Format the count value without decimal places
          const formattedCount = currentValue.toLocaleString('en-US', { maximumFractionDigits: 0 });


          if (label.includes('No Data')) {
            return `${label}`;
          }
          // Return the label and count
          return `(${formattedCount}) ${label}`;
        },
        title: (tooltipItems, data) => {
          return data.labels[tooltipItems[0].index];
        }
      }
    },
    hover: {
      mode: 'nearest',
      intersect: false,
      animationDuration: 0 // Speed up tooltip appearance
    }
  };

  // Get pipeline data for month view
  getPipelineDataForMonth(month: number): any {
    if (!this.ListProjectPipeline) {
      // Return default empty chart data with a placeholder
      return {
        labels: ['No Data'],
        data: [1],
        colors: ['#e0e0e0']
      };
    }

    // Log the month we're filtering by for debugging
    //console.log('Getting pipeline data for month:', month);

    // Filter pipelines for the specific month using our helper method
    const monthPipelines = this.filterPipelinesByDate(this.ListProjectPipeline, month);


    // Define an interface for the pipeline object to ensure type safety
    interface PipelineItem {
      ProjectSaleCode: string;
      ProjectPipelineStatusLookupCode: string;
      ProjectPipelineAmount: string;
      ProjectPipelineSubStateCode?: string;
      //ProjectSaleServiceDeliveryStatus?: string;
      ProjectSaleState?: string;
      ProjectSaleServiceDeliveryWaitingAmount?: string;
      ProjectSaleServiceDeliveryNewBusinessAmount?: string;
      ServiceDeliveryBacklogDetailListWaiting?: ServiceDeliveryBacklogDetailInfo[];
      ServiceDeliveryBacklogDetailListNewBusiness?: ServiceDeliveryBacklogDetailInfo[];
    }

    // Split pipelines into two groups: those with status codes 1-5 and others
    const pipelinesToGroup = monthPipelines.filter(pipeline =>
      ['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );
    const otherPipelines = monthPipelines.filter(pipeline =>
      !['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );

    // First, group by ProjectSaleCode and get the highest status for each project
    const groupedByProject = pipelinesToGroup.reduce((acc, pipeline) => {
      if (!acc[pipeline.ProjectSaleCode]) {
        acc[pipeline.ProjectSaleCode] = pipeline;
      } else {
        // Update with higher status if found
        if (Number(pipeline.ProjectPipelineStatusLookupCode) > Number(acc[pipeline.ProjectSaleCode].ProjectPipelineStatusLookupCode)) {
          acc[pipeline.ProjectSaleCode] = pipeline;
        }
      }
      return acc;
    }, {} as { [key: string]: PipelineItem });

    // Get the array of highest status pipelines
    const highestStatusPipelines = [...Object.values(groupedByProject), ...otherPipelines] as PipelineItem[];

    if (highestStatusPipelines.length === 0) {
      return {
        labels: ['No Data'],
        data: [1],
        colors: ['#e0e0e0']
      };
    }

    // Count for all categories
    let frontlogCount = 0;
    let backlogCount = 0;
    let newBusinessCount = 0;
    let suspendedCount = 0;
    let terminateCount = 0;
    let closedWonCount = 0;
    let closedLostCount = 0;

    let frontlogAmount = 0;
    let backlogAmount = 0;
    let newBusinessAmount = 0;
    let suspendedAmount = 0;
    let terminateAmount = 0;
    let closedWonAmount = 0;
    let closedLostAmount = 0;

    let frontlogAmountTxt = '';
    let backlogAmountTxt = '';
    let newBusinessAmountTxt = '';
    let suspendedAmountTxt = '';
    let terminateAmountTxt = '';
    let closedWonAmountTxt = '';
    let closedLostAmountTxt = '';

    //console.log(monthPipelines);
    // Process each pipeline in the month
    highestStatusPipelines.forEach(pipeline => {
      const status = pipeline.ProjectPipelineStatusLookupCode;
      const amount = parseFloat(pipeline.ProjectPipelineAmount.toString()) || 0;

      // Combine statuses 1-5 into Frontlog - only count if not Backlog or New Business
      if ((['1', '2', '3', '4', '5'].includes(status)) &&
        pipeline.ProjectPipelineSubStateCode != '1-5-1' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-2' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-1-PLACEHOLDER' &&
        pipeline.ProjectSaleState !== '1-9' &&
        pipeline.ProjectSaleState !== '0') {
        frontlogCount++;
        frontlogAmount += amount;
      }

      

      // Check for Backlog - ensure ProjectSaleServiceDeliveryStatus is not null/undefined
      if (pipeline.ProjectPipelineSubStateCode == '1-5-1-PLACEHOLDER') {
        let backlogAmountTemp = parseFloat(pipeline.ProjectSaleServiceDeliveryWaitingAmount) || 0;
        let newBusinessAmountTemp = parseFloat(pipeline.ProjectSaleServiceDeliveryNewBusinessAmount) || 0;
        if (pipeline.ServiceDeliveryBacklogDetailListWaiting.length > 0) {
          backlogCount += pipeline.ServiceDeliveryBacklogDetailListWaiting.length;
          backlogAmount += backlogAmountTemp;
        }
        if (pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length > 0) {
          newBusinessCount += pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length;
          newBusinessAmount += newBusinessAmountTemp;
        }
      }

      // Check for Suspended status
      if (pipeline.ProjectSaleState === '1-9') {
        suspendedCount++;
        suspendedAmount += amount;
      }

      // Check for Terminate status
      if (pipeline.ProjectSaleState === '0') {
        terminateCount++;
        terminateAmount += amount;
      }

      // Check for Closed Lost status
      if (pipeline.ProjectPipelineSubStateCode === '1-5-2') {
        closedLostCount++;
        closedLostAmount += amount;
      }

      // Check for Closed Won status
      if (pipeline.ProjectPipelineSubStateCode === '1-5-1') {
        closedWonCount++;
        closedWonAmount += amount;
      }
    });

    // Format amount text after summing all values
    frontlogAmountTxt = frontlogAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    backlogAmountTxt = backlogAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    newBusinessAmountTxt = newBusinessAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    suspendedAmountTxt = suspendedAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    terminateAmountTxt = terminateAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    closedWonAmountTxt = closedWonAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    closedLostAmountTxt = closedLostAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });

    // Format for chart
    const labels = [];
    const data = [];
    const colors = [];

    // Add Frontlog (combined statuses 1-5)
    if (frontlogCount > 0) {
      labels.push('Frontlog - ' + frontlogAmountTxt + ' THB');
      data.push(frontlogCount);
      colors.push('#205F9A'); // Blue color for Frontlog
    }

    // Add Backlog
    if (backlogCount > 0) {
      labels.push('Backlog - ' + backlogAmountTxt + ' THB');
      data.push(backlogCount);
      colors.push('#FF9F43'); // Orange color for Backlog
    }

    // Add New Business
    if (newBusinessCount > 0) {
      labels.push('New Business - ' + newBusinessAmountTxt + ' THB');
      data.push(newBusinessCount);
      colors.push('#FEE599'); // Yellow color for New Business
    }

    // Add Suspended
    if (suspendedCount > 0) {
      labels.push('Suspended - ' + suspendedAmountTxt + ' THB');
      data.push(suspendedCount);
      colors.push('#8B4513'); // Brown color for Suspended
    }

    // Add Terminate
    if (terminateCount > 0) {
      labels.push('Terminate - ' + terminateAmountTxt + ' THB');
      data.push(terminateCount);
      colors.push('#444444'); // Dark Grey color for Terminate
    }

    // Add Lost
    if (closedLostCount > 0) {
      labels.push('Lost - ' + closedLostAmountTxt + ' THB');
      data.push(closedLostCount);
      colors.push('#FF0000'); // Red color for Lost
    }

    // Add Won
    if (closedWonCount > 0) {
      labels.push('Won - ' + closedWonAmountTxt + ' THB');
      data.push(closedWonCount);
      colors.push('#008800'); // Green color for Won
    }

    // If no data after all the filtering, return a placeholder chart
    if (labels.length === 0) {
      return {
        labels: ['No Data'],
        data: [1],
        colors: ['#e0e0e0']
      };
    }

    return { labels, data, colors };
  }

  // Get pipeline data for quarter view
  getPipelineDataForQuarter(quarter: number): any {
    if (!this.ListProjectPipeline) {
      // Return default empty chart data with a placeholder
      return {
        labels: ['No Data'],
        data: [1],
        colors: ['#e0e0e0']
      };
    }

    // Log the quarter we're filtering by for debugging
    //console.log('Getting pipeline data for quarter:', quarter);

    // Calculate start and end months for the quarter
    const startMonth = (quarter - 1) * 3;
    const endMonth = startMonth + 2;

    // Filter pipelines for the specific quarter using our helper method
    const quarterPipelines = this.filterPipelinesByDate(this.ListProjectPipeline, undefined, quarter);

    // Define an interface for the pipeline object to ensure type safety
    interface PipelineItem {
      ProjectSaleCode: string;
      ProjectPipelineStatusLookupCode: string;
      ProjectPipelineAmount: string;
      ProjectPipelineSubStateCode?: string;
      //ProjectSaleServiceDeliveryStatus?: string;
      ProjectSaleState?: string;
      ProjectSaleServiceDeliveryWaitingAmount?: string;
      ProjectSaleServiceDeliveryNewBusinessAmount?: string;
      ServiceDeliveryBacklogDetailListWaiting?: ServiceDeliveryBacklogDetailInfo[];
      ServiceDeliveryBacklogDetailListNewBusiness?: ServiceDeliveryBacklogDetailInfo[];
    }

    // Split pipelines into two groups: those with status codes 1-5 and others
    const pipelinesToGroup = quarterPipelines.filter(pipeline =>
      ['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );
    const otherPipelines = quarterPipelines.filter(pipeline =>
      !['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );

    // First, group by ProjectSaleCode and get the highest status for each project
    const groupedByProject = pipelinesToGroup.reduce((acc, pipeline) => {
      if (!acc[pipeline.ProjectSaleCode]) {
        acc[pipeline.ProjectSaleCode] = pipeline;
      } else {
        // Update with higher status if found
        if (Number(pipeline.ProjectPipelineStatusLookupCode) > Number(acc[pipeline.ProjectSaleCode].ProjectPipelineStatusLookupCode)) {
          acc[pipeline.ProjectSaleCode] = pipeline;
        }
      }
      return acc;
    }, {} as { [key: string]: PipelineItem });

    // Get the array of highest status pipelines
    const highestStatusPipelines = [...Object.values(groupedByProject), ...otherPipelines] as PipelineItem[];

    if (highestStatusPipelines.length === 0) {
      return {
        labels: ['No Data'],
        data: [1],
        colors: ['#e0e0e0']
      };
    }

    // Count for all categories
    let frontlogCount = 0;
    let backlogCount = 0;
    let newBusinessCount = 0;
    let suspendedCount = 0;
    let terminateCount = 0;
    let closedWonCount = 0;
    let closedLostCount = 0;

    let frontlogAmount = 0;
    let backlogAmount = 0;
    let newBusinessAmount = 0;
    let suspendedAmount = 0;
    let terminateAmount = 0;
    let closedWonAmount = 0;
    let closedLostAmount = 0;

    let frontlogAmountTxt = '';
    let backlogAmountTxt = '';
    let newBusinessAmountTxt = '';
    let suspendedAmountTxt = '';
    let terminateAmountTxt = '';
    let closedLostAmountTxt = '';
    let closedWonAmountTxt = '';

    // Process each pipeline in the quarter
    highestStatusPipelines.forEach(pipeline => {
      const status = pipeline.ProjectPipelineStatusLookupCode;
      const amount = parseFloat(pipeline.ProjectPipelineAmount.toString()) || 0;

      // Combine statuses 1-5 into Frontlog - only count if not Backlog or New Business
      if ((['1', '2', '3', '4', '5'].includes(status)) &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-1' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-2' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-1-PLACEHOLDER' &&
        pipeline.ProjectSaleState !== '1-9' &&
        pipeline.ProjectSaleState !== '0') {
        frontlogCount++;
        frontlogAmount += amount;
      }

      // Check for Backlog - ensure ProjectSaleServiceDeliveryStatus is not null/undefined
      if (pipeline.ProjectPipelineSubStateCode === '1-5-1-PLACEHOLDER') {
        let backlogAmountTemp = parseFloat(pipeline.ProjectSaleServiceDeliveryWaitingAmount) || 0;
        let newBusinessAmountTemp = parseFloat(pipeline.ProjectSaleServiceDeliveryNewBusinessAmount) || 0;
        backlogCount += pipeline.ServiceDeliveryBacklogDetailListWaiting.length <= 0 && backlogAmountTemp > 0 ? 1 : pipeline.ServiceDeliveryBacklogDetailListWaiting.length;
        backlogAmount += backlogAmountTemp;
        newBusinessCount += pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length <= 0 && newBusinessAmountTemp > 0 ? 1 : pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length;
        newBusinessAmount += newBusinessAmountTemp;
      }

      // Check for Suspended status
      if (pipeline.ProjectSaleState === '1-9') {
        suspendedCount++;
        suspendedAmount += amount;
      }

      // Check for Terminate status
      if (pipeline.ProjectSaleState === '0') {
        terminateCount++;
        terminateAmount += amount;
      }

      // Check for Closed Lost status
      if (pipeline.ProjectPipelineSubStateCode === '1-5-2') {
        closedLostCount++;
        closedLostAmount += amount;
      }

      // Check for Closed Won status
      if (pipeline.ProjectPipelineSubStateCode === '1-5-1') {
        closedWonCount++;
        closedWonAmount += amount;
      }
    });

    // Format amount text after summing all values
    frontlogAmountTxt = frontlogAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    backlogAmountTxt = backlogAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    newBusinessAmountTxt = newBusinessAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    suspendedAmountTxt = suspendedAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    terminateAmountTxt = terminateAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    closedLostAmountTxt = closedLostAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });
    closedWonAmountTxt = closedWonAmount.toLocaleString('en-US', { maximumFractionDigits: 2 });

    // Format for chart
    const labels = [];
    const data = [];
    const colors = [];

    // Add Frontlog (combined statuses 1-5)
    if (frontlogCount > 0) {
      labels.push('Frontlog - ' + frontlogAmountTxt + ' THB');
      data.push(frontlogCount);
      colors.push('#205F9A'); // Blue color for Frontlog
    }

    // Add Backlog
    if (backlogCount > 0) {
      labels.push('Waiting - ' + backlogAmountTxt + ' THB');
      data.push(backlogCount);
      colors.push('#FF9F43'); // Orange color for Backlog
    }

    // Add New Business
    if (newBusinessCount > 0) {
      labels.push('New Business - ' + newBusinessAmountTxt + ' THB');
      data.push(newBusinessCount);
      colors.push('#FEE599'); // Yellow color for New Business
    }

    // Add Suspended
    if (suspendedCount > 0) {
      labels.push('Suspended - ' + suspendedAmountTxt + ' THB');
      data.push(suspendedCount);
      colors.push('#8B4513'); // Brown color for Suspended
    }

    // Add Terminate
    if (terminateCount > 0) {
      labels.push('Terminate - ' + terminateAmountTxt + ' THB');
      data.push(terminateCount);
      colors.push('#444444'); // Dark Grey color for Terminate
    }

    // Add Lost
    if (closedLostCount > 0) {
      labels.push('Lost - ' + closedLostAmountTxt + ' THB');
      data.push(closedLostCount);
      colors.push('#FF0000'); // Red color for Lost
    }

    // Add Won
    if (closedWonCount > 0) {
      labels.push('Won - ' + closedWonAmountTxt + ' THB');
      data.push(closedWonCount);
      colors.push('#008800'); // Green color for Won
    }

    // If no data after all the filtering, return a placeholder chart
    if (labels.length === 0) {
      return {
        labels: ['No Data'],
        data: [1],
        colors: ['#e0e0e0']
      };
    }

    return { labels, data, colors };
  }

  // Get pipeline labels
  getPipelineLabels(): string[] {
    return this.PipelineStatusList.map(status => status.LookupValue);
  }

  // Get pipeline colors
  getPipelineColors(): string[] {
    return this.PipelineStatusList.map(status => this.getStatusColor(status.LookupCode));
  }

  // Get total pipeline count for a month
  getPipelineCountForMonth(month: number): number {
    if (!this.ListProjectPipeline) return 0;

    const monthPipelines = this.filterPipelinesByDate(this.ListProjectPipeline, month);

    // Define an interface for the pipeline object to ensure type safety
    interface PipelineItem {
      ProjectSaleCode: string;
      ProjectPipelineStatusLookupCode: string;
      ProjectPipelineAmount: string;
      ProjectPipelineSubStateCode?: string;
      //ProjectSaleServiceDeliveryStatus?: string;
      ProjectSaleState?: string;
      ProjectSaleServiceDeliveryWaitingAmount?: string;
      ProjectSaleServiceDeliveryNewBusinessAmount?: string;
      ServiceDeliveryBacklogDetailListWaiting?: ServiceDeliveryBacklogDetailInfo[];
      ServiceDeliveryBacklogDetailListNewBusiness?: ServiceDeliveryBacklogDetailInfo[];
    }

    // Split pipelines into two groups: those with status codes 1-5 and others
    const pipelinesToGroup = monthPipelines.filter(pipeline =>
      ['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );
    const otherPipelines = monthPipelines.filter(pipeline =>
      !['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );

    // First, group by ProjectSaleCode and get the highest status for each project
    const groupedByProject = pipelinesToGroup.reduce((acc, pipeline) => {
      if (!acc[pipeline.ProjectSaleCode]) {
        acc[pipeline.ProjectSaleCode] = pipeline;
      } else {
        // Update with higher status if found
        if (Number(pipeline.ProjectPipelineStatusLookupCode) > Number(acc[pipeline.ProjectSaleCode].ProjectPipelineStatusLookupCode)) {
          acc[pipeline.ProjectSaleCode] = pipeline;
        }
      }
      return acc;
    }, {} as { [key: string]: PipelineItem });

    // Get the array of highest status pipelines
    const highestStatusPipelines = [...Object.values(groupedByProject), ...otherPipelines] as PipelineItem[];

    let frontlogCount = 0;
    let backlogCount = 0;
    let newBusinessCount = 0;
    let suspendedCount = 0;
    let terminateCount = 0;
    let closedWonCount = 0;
    let closedLostCount = 0;

    highestStatusPipelines.forEach(pipeline => {
      const status = pipeline.ProjectPipelineStatusLookupCode;
      if ((['1', '2', '3', '4', '5'].includes(status)) &&
        pipeline.ProjectPipelineSubStateCode != '1-5-1' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-2' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-1-PLACEHOLDER' &&
        pipeline.ProjectSaleState !== '1-9' &&
        pipeline.ProjectSaleState !== '0') {
        frontlogCount++;
      } else if (pipeline.ProjectPipelineSubStateCode === '1-5-1-PLACEHOLDER') {
        if (pipeline.ServiceDeliveryBacklogDetailListWaiting.length > 0) {
          backlogCount += pipeline.ServiceDeliveryBacklogDetailListWaiting.length;
        }
        if (pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length > 0) {
          newBusinessCount += pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length;
        }
      } else if (pipeline.ProjectSaleState === '1-9') {
        suspendedCount++;
      } else if (pipeline.ProjectSaleState === '0') {
        terminateCount++;
      } else if (pipeline.ProjectPipelineSubStateCode === '1-5-2') {
        closedLostCount++;
      } else if (pipeline.ProjectPipelineSubStateCode === '1-5-1') {
        closedWonCount++;
      }
    });

    return frontlogCount + backlogCount + newBusinessCount + suspendedCount + terminateCount + closedWonCount + closedLostCount;
  }

  // Get total pipeline count for a quarter
  getPipelineCountForQuarter(quarter: number): number {
    if (!this.ListProjectPipeline) return 0;

    const startMonth = (quarter - 1) * 3;
    const endMonth = startMonth + 2;

    const quarterPipelines = this.filterPipelinesByDate(this.ListProjectPipeline, undefined, quarter);

    // Define an interface for the pipeline object to ensure type safety
    interface PipelineItem {
      ProjectSaleCode: string;
      ProjectPipelineStatusLookupCode: string;
      ProjectPipelineAmount: string;
      ProjectPipelineSubStateCode?: string;
      //ProjectSaleServiceDeliveryStatus?: string;
      ProjectSaleState?: string;
      ProjectSaleServiceDeliveryWaitingAmount?: string;
      ProjectSaleServiceDeliveryNewBusinessAmount?: string;
      ServiceDeliveryBacklogDetailListWaiting?: ServiceDeliveryBacklogDetailInfo[];
      ServiceDeliveryBacklogDetailListNewBusiness?: ServiceDeliveryBacklogDetailInfo[];
    }

    // Split pipelines into two groups: those with status codes 1-5 and others
    const pipelinesToGroup = quarterPipelines.filter(pipeline =>
      ['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );
    const otherPipelines = quarterPipelines.filter(pipeline =>
      !['1', '2', '3', '4', '5'].includes(pipeline.ProjectPipelineStatusLookupCode)
    );

    // First, group by ProjectSaleCode and get the highest status for each project
    const groupedByProject = pipelinesToGroup.reduce((acc, pipeline) => {
      if (!acc[pipeline.ProjectSaleCode]) {
        acc[pipeline.ProjectSaleCode] = pipeline;
      } else {
        // Update with higher status if found
        if (Number(pipeline.ProjectPipelineStatusLookupCode) > Number(acc[pipeline.ProjectSaleCode].ProjectPipelineStatusLookupCode)) {
          acc[pipeline.ProjectSaleCode] = pipeline;
        }
      }
      return acc;
    }, {} as { [key: string]: PipelineItem });

    // Get the array of highest status pipelines
    const highestStatusPipelines = [...Object.values(groupedByProject), ...otherPipelines] as PipelineItem[];

    let frontlogCount = 0;
    let backlogCount = 0;
    let newBusinessCount = 0;
    let suspendedCount = 0;
    let terminateCount = 0;
    let closedLostCount = 0;
    let closedWonCount = 0;

    highestStatusPipelines.forEach(pipeline => {
      const status = pipeline.ProjectPipelineStatusLookupCode;
      if ((['1', '2', '3', '4', '5'].includes(status)) &&
        pipeline.ProjectPipelineSubStateCode != '1-5-1' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-2' &&
        pipeline.ProjectPipelineSubStateCode !== '1-5-1-PLACEHOLDER' &&
        pipeline.ProjectSaleState !== '1-9' &&
        pipeline.ProjectSaleState !== '0') {
        frontlogCount++;
      } else if (pipeline.ProjectPipelineSubStateCode === '1-5-1-PLACEHOLDER') {
        if (pipeline.ServiceDeliveryBacklogDetailListWaiting.length > 0) {
          backlogCount += pipeline.ServiceDeliveryBacklogDetailListWaiting.length;
        }
        if (pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length > 0) {
          newBusinessCount += pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length;
        }
      } else if (pipeline.ProjectSaleState === '1-9') {
        suspendedCount++;
      } else if (pipeline.ProjectSaleState === '0') {
        terminateCount++;
      } else if (pipeline.ProjectPipelineSubStateCode === '1-5-2') {
        closedLostCount++;
      } else if (pipeline.ProjectPipelineSubStateCode === '1-5-1') {
        closedWonCount++;
      }
    });

    return frontlogCount + backlogCount + newBusinessCount + suspendedCount + terminateCount + closedLostCount + closedWonCount;
  }

  // Check if we're in quarter view
  public get isQuarterView(): boolean {
    return this.ChartType === 'Quarter';
  }

  // Helper method to check for undefined strings
  checkUndefinedString(value: any): string {
    if (value === undefined || value === null) {
      return "";
    }
    return value;
  }

  // Helper method to safely parse dates from ISO format
  parsePipelineDate(dateStr: string): Date | null {
    if (!dateStr) return null;
    try {
      // Handle ISO date format like '2025-06-04T08:29:36.35'
      return new Date(dateStr);
    } catch (e) {
      console.error('Error parsing date:', dateStr, e);
      return null;
    }
  }

  // Helper method to filter pipelines by month or quarter
  filterPipelinesByDate(pipelines: any[], month?: number, quarter?: number): any[] {
    if (!pipelines || pipelines.length === 0) return [];

    let filteredPipelines = [];

    for (const pipeline of pipelines) {
      // Special handling for pipelines with ProjectPipelineSubStateCode == '1-5-1'
      if (pipeline.ProjectPipelineSubStateCode === '1-5-1') {
        let includeThisPipeline = false;

        // Filter ServiceDeliveryBacklogDetailListWaiting based on ServiceDeliveryBacklogDetailEstimateDate
        let filteredWaitingList = [];
        if (pipeline.ServiceDeliveryBacklogDetailListWaiting && pipeline.ServiceDeliveryBacklogDetailListWaiting.length > 0) {
          if (month !== undefined && month >= 0) {
            filteredWaitingList = pipeline.ServiceDeliveryBacklogDetailListWaiting.filter(item => {
              const itemDate = this.parsePipelineDate(item.ServiceDeliveryBacklogDetailEstimateDate);
              return itemDate && itemDate.getMonth() === month &&
                itemDate.getFullYear() === this.CurrentYear;
            });
          } else if (quarter !== undefined && quarter > 0) {
            const startMonth = (quarter - 1) * 3;
            const endMonth = startMonth + 2;

            filteredWaitingList = pipeline.ServiceDeliveryBacklogDetailListWaiting.filter(item => {
              const itemDate = this.parsePipelineDate(item.ServiceDeliveryBacklogDetailEstimateDate);
              return itemDate &&
                itemDate.getMonth() >= startMonth &&
                itemDate.getMonth() <= endMonth &&
                itemDate.getFullYear() === this.CurrentYear;
            });
          } else {
            // If no month or quarter filter, include all
            filteredWaitingList = [...pipeline.ServiceDeliveryBacklogDetailListWaiting];
          }
        }

        // Filter ServiceDeliveryBacklogDetailListNewBusiness based on ServiceDeliveryBacklogDetailActualDate
        let filteredNewBusinessList = [];
        if (pipeline.ServiceDeliveryBacklogDetailListNewBusiness && pipeline.ServiceDeliveryBacklogDetailListNewBusiness.length > 0) {
          if (month !== undefined && month >= 0) {
            filteredNewBusinessList = pipeline.ServiceDeliveryBacklogDetailListNewBusiness.filter(item => {
              const itemDate = this.parsePipelineDate(item.ServiceDeliveryBacklogDetailActualDate);
              return itemDate && itemDate.getMonth() === month &&
                itemDate.getFullYear() === this.CurrentYear;
            });
          } else if (quarter !== undefined && quarter > 0) {
            const startMonth = (quarter - 1) * 3;
            const endMonth = startMonth + 2;

            filteredNewBusinessList = pipeline.ServiceDeliveryBacklogDetailListNewBusiness.filter(item => {
              const itemDate = this.parsePipelineDate(item.ServiceDeliveryBacklogDetailActualDate);
              return itemDate &&
                itemDate.getMonth() >= startMonth &&
                itemDate.getMonth() <= endMonth &&
                itemDate.getFullYear() === this.CurrentYear;
            });
          } else {
            // If no month or quarter filter, include all
            filteredNewBusinessList = [...pipeline.ServiceDeliveryBacklogDetailListNewBusiness];
          }
        }

        // Include this pipeline if either filtered list has items
        if (filteredWaitingList.length > 0 || filteredNewBusinessList.length > 0) {
          // Create a copy of the pipeline with filtered lists
          const pipelineCopy = { ...pipeline };
          pipelineCopy.ServiceDeliveryBacklogDetailListWaiting = filteredWaitingList;
          pipelineCopy.ProjectSaleServiceDeliveryWaitingAmount = filteredWaitingList.reduce((sum, item) => sum + (item.ServiceDeliveryBacklogDetailPrice || 0), 0);
          pipelineCopy.ServiceDeliveryBacklogDetailListNewBusiness = filteredNewBusinessList;
          pipelineCopy.ProjectSaleServiceDeliveryNewBusinessAmount = filteredNewBusinessList.reduce((sum, item) => sum + (item.ServiceDeliveryBacklogDetailPrice || 0), 0);
          pipelineCopy.ProjectPipelineSubStateCode = '1-5-1-PLACEHOLDER';
          filteredPipelines.push(pipelineCopy);

          //continue;

        }
      }

      // Regular handling for other pipelines based on ProjectSaleCreateDate
      if (month !== undefined && month >= 0) {
        // Filter by month
        const pipelineDate = this.parsePipelineDate(pipeline.ProjectSaleCreateDate);
        if (pipelineDate && pipelineDate.getMonth() === month &&
          pipelineDate.getFullYear() === this.CurrentYear) {
          filteredPipelines.push(pipeline);
        }
      } else if (quarter !== undefined && quarter > 0) {
        // Filter by quarter
        const startMonth = (quarter - 1) * 3;
        const endMonth = startMonth + 2;

        const pipelineDate = this.parsePipelineDate(pipeline.ProjectSaleCreateDate);
        if (pipelineDate &&
          pipelineDate.getMonth() >= startMonth &&
          pipelineDate.getMonth() <= endMonth &&
          pipelineDate.getFullYear() === this.CurrentYear) {
          filteredPipelines.push(pipeline);
        }
      } else {
        // No month or quarter filter
        filteredPipelines.push(pipeline);
      }


    }

    return filteredPipelines;
  }

  /******************************* Functions ********************************/
}
